/* global _api */
import _ from "lodash";
import React, { Component } from "react";
import PropagateLoader from 'react-spinners/PropagateLoader';
import Card from "../../../components/Card/Card.jsx";
import Checkbox from "../../../components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "../../../components/CustomButton/CustomButton.jsx";
import MapCard from "../../../components/Card/MapCard.jsx";
import DirectionsMap from "../../../components/Map/DirectionsMap.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import ExpertElementsListComponent from "../../../components/Expert/ElementsListComponent.jsx"
import Select from "react-select";
import { DebounceInput } from 'react-debounce-input';
import ExpertUploadComponent from "../../../components/Expert/UploadComponent.jsx";
import moment from 'moment';
import {
    Grid,
    Row,
    Col,
    FormGroup,
    FormControl,
    ControlLabel
} from "react-bootstrap";
import { $STATUS2_DOSTARCZONE, $STATUS2_NIEZREALIZOWANE, $STATUS2_NOWE, $STATUS2_NOWEDOTRANSFERU, $STATUS2_ROBOCZE, $STATUS2_ROZPOCZECIEMONTAZU, $STATUS2_WDOSTAWIE, $STATUS2_ZGLOSZONOREKLAMACJE, $STATUS2_ZWROT } from "../../../constants.js";
import { isIkeaCompany } from "../../../utils/integrations";

const STATUSES_REQUIRING_DEVIATION_CODE = [
    $STATUS2_NIEZREALIZOWANE
];

const BASE_STATUS_OPTIONS = [
    { value: $STATUS2_ROBOCZE, label: $STATUS2_ROBOCZE },
    { value: $STATUS2_NOWE, label: $STATUS2_NOWE },
    { value: $STATUS2_WDOSTAWIE, label: $STATUS2_WDOSTAWIE },
    { value: $STATUS2_DOSTARCZONE, label: $STATUS2_DOSTARCZONE },
    { value: $STATUS2_NIEZREALIZOWANE, label: $STATUS2_NIEZREALIZOWANE },
    { value: $STATUS2_NOWEDOTRANSFERU, label: $STATUS2_NOWEDOTRANSFERU },
    { value: $STATUS2_ZGLOSZONOREKLAMACJE, label: $STATUS2_ZGLOSZONOREKLAMACJE },
    { value: $STATUS2_ZWROT, label: $STATUS2_ZWROT },
];

const IKEA_ALLOWED_FILE_EXTENSIONS = [
    "txt",
    "docx",
    "xlsx",
    "xls",
    "jpg",
    "tif",
    "doc",
    "ppt",
    "gif",
    "pptx",
    "jpeg",
    "pdf",
    "tiff"
];

export class ExpertClientOrder extends Component {

    constructor(props) {
        super(props);
        const initialConfiguration = this.props.user.user.company.configuration;
        const initialIsIkeaOrder = isIkeaCompany(this.props.user.user.company);
        this.state = {
            uuid: "",
            ident: "",
            userOwner: this.props.user.user || null,
            status: null,
            orderStatus: null,
            name: "",
            type: "",
            serviceType: "",
            estimatedHours: "",
            deviationCode: "",
            identExternal: "",
            identExternalVoucher: "",
            discountValue: "",
            postalCode: "",
            cityName: "",
            streetAddress: "",
            streetNumber: "",
            apartmentNumber: "",
            apartmentFloor: "",
            contactPerson: "",
            emailAddress: "",
            mobilePhone: "",
            geoLat: "",
            geoLng: "",
            payer: "",
            fullAddress: "",
            slot: "",
            comment: "",
            cod: "",
            settled: false,
            wasSettled: false,
            express: false,
            transferable: false,
            delayRequest: false,
            withoutDelivery: false,
            allowNoBringing: false,
            elevator: false,
            trash: false,
            extraBringing: false,
            extraAssembly: false,
            calculatedWeight: 0,
            calculatedSize: 0,
            calculatedZone: "",
            calculatedZoneData: {},
            calculatedDistance: "",
            calculatedPriceClient: "",
            ikeaAssemblyTimeTotalMinutes: "",
            ikeaSumNetValue: "",
            manualPriceClient: false,
            calculatedPoints: "1",
            calculateDeliveryFromWarehouse: false,
            availableSlots: [],
            isLoading: false,
            orderLoading: true,
            isAdminView: this.props.isAdminView || false,
            isPreviewOnly: this.props.isPreviewOnly || false,
            currentDay: this.props.selectedDay || moment(),
            nextDaySpan: this.props.nextDaySpan || 31,
            calculatedSlotDelay: 0,
            payerOptions: this.props.user.user.company.configuration.order.payment.payer,
            orderService: [],
            orderElement: [],
            availableSchedule: [],
            currentFiles: [],
            additionalFiles: [],
            children: [],
            commentFleet: "",
            commentExpert: "",
            keepSlot: "",
            schedule: null,
            keepSchedule: "",
            department: this.props.department || this.props.user.user.department.uuid,
            numberOfSpans: this.props.numberOfSpans || this.props.user.user.company.numberOfSpans,
            availableServices: this.props.user.user.company.service || [],
            ikeaServices: [],
            selectedIkeaServiceKey: null,
            initialIkeaServicesSnapshot: [],
            expandedIkeaServiceHistory: {},
            releaseElements: this.props.user.user.company.configuration.order.additionalFields.hasOwnProperty('releaseElements'),
            warehouse: { value: "other", label: "Inny" },
            warehousePlainText: "",
            warehouseType: "other",
            warehouses: [],
            statusOptions: this.getStatusOptions(initialIsIkeaOrder, initialConfiguration),
            availableTypes: [
                { value: "delivery", label: "Dostawa" },
                { value: "assembly", label: "Montaż" }
            ],
            commonWarehouses: [
                { value: "pickup", label: "Odbiór od klienta" },
                { value: "other", label: "Inny" }
            ],

            lastMileWarehouseName: '',
            lastMileWarehouseStreetNumber: '',
            lastMileWarehouseStreetAddress: '',
            lastMileWarehouseCityName: '',
            lastMileWarehousePostalCode: '',
            lastMileWarehouseaPartmentNumber: '',
            lastMileWarehouseaPartmentFloor: '',
            lastMileWarehouseElevator: '',
            lastMileWarehouseContactPerson: '',
            lastMileWarehouseEmailAddress: '',
            lastMileWarehouseMobilePhone: '',
            lastMileWarehouseGeoLat: '',
            lastMileWarehouseGeoLng: '',

            realUserCompanyName: '',
            lastMileWarehouseCompanyUuid: '',
            canEditLockedOrders: false,
            isIkeaOrder: initialIsIkeaOrder,
        };
        this.tOutSlot = undefined;
        this.onRefreshOrder = this.onRefreshOrder.bind(this);
    }

    getStatusOptions(isIkeaOrder, configuration) {
        if (isIkeaOrder) {
            const ikeaStatusOptions = this.getConfigurationStatusOptions(configuration);
            if (ikeaStatusOptions.length) {
                return ikeaStatusOptions;
            }
        }

        let statusOptions = [...BASE_STATUS_OPTIONS];
        if (isIkeaOrder) {
            statusOptions.push({ value: $STATUS2_ROZPOCZECIEMONTAZU, label: $STATUS2_ROZPOCZECIEMONTAZU });
        }
        return statusOptions;
    }

    getConfigurationStatusOptions(configuration) {
        if (!configuration || !configuration.order || !configuration.order.statuses) {
            return [];
        }
        const { options } = configuration.order.statuses;
        if (!Array.isArray(options)) {
            return [];
        }

        return options
            .filter(option => option && typeof option.value === "string" && option.value.length)
            .map(option => ({
                value: option.value,
                label: option.label || option.value
            }));
    }

    getCompanyConfiguration() {
        if (this.state.userOwner && this.state.userOwner.company) {
            return this.state.userOwner.company.configuration;
        }
        if (this.props.user && this.props.user.user && this.props.user.user.company) {
            return this.props.user.user.company.configuration;
        }
        return null;
    }

    getDeviationFieldConfiguration(configuration) {
        const companyConfiguration = configuration || this.getCompanyConfiguration();
        if (!companyConfiguration || !companyConfiguration.order || !companyConfiguration.order.additionalFields) {
            return null;
        }
        return companyConfiguration.order.additionalFields.deviationCode || null;
    }

    hasDeviationCodeRules(configuration) {
        const deviationField = this.getDeviationFieldConfiguration(configuration);
        return !!(deviationField && deviationField.requiredForStatuses && Object.keys(deviationField.requiredForStatuses).length);
    }

    getAllDeviationCodeOptions(configuration) {
        const deviationField = this.getDeviationFieldConfiguration(configuration);
        if (!deviationField || !Array.isArray(deviationField.options)) {
            return [];
        }
        return deviationField.options;
    }

    getDeviationCodeOptionsForStatusValue(statusValue, configuration) {
        if (!statusValue) {
            return [];
        }
        const deviationField = this.getDeviationFieldConfiguration(configuration);
        if (!deviationField || !deviationField.requiredForStatuses) {
            return [];
        }
        const allowedValues = deviationField.requiredForStatuses[statusValue];
        if (!Array.isArray(allowedValues) || !allowedValues.length) {
            return [];
        }
        const allOptions = this.getAllDeviationCodeOptions(configuration);
        return allowedValues
            .map(value => allOptions.find(option => option && option.value === value))
            .filter(Boolean);
    }

    sanitizeDeviationCodeValue(statusValue, deviationCode, configuration) {
        const normalizedDeviationCode = deviationCode || "";
        if (!this.hasDeviationCodeRules(configuration)) {
            return normalizedDeviationCode;
        }
        const allowedOptions = this.getDeviationCodeOptionsForStatusValue(statusValue, configuration);
        if (!allowedOptions.length) {
            return "";
        }
        return allowedOptions.some(option => option.value === normalizedDeviationCode) ? normalizedDeviationCode : "";
    }

    getIkeaServiceDetails(orderDetails) {
        if (orderDetails && Array.isArray(orderDetails.services) && orderDetails.services.length) {
            return orderDetails.services;
        }
        if (orderDetails && orderDetails.order && Array.isArray(orderDetails.order.services) && orderDetails.order.services.length) {
            return orderDetails.order.services;
        }
        return [];
    }

    getIkeaServicesForCurrentOrder = () => {
        return Array.isArray(this.state.ikeaServices) ? this.state.ikeaServices : [];
    }

    shouldUseServiceStatusManagement = () => {
        return this.state.isIkeaOrder && this.getIkeaServicesForCurrentOrder().length > 0;
    }

    getIkeaServiceInternalKey = (service, index) => {
        if (service && service.__key) {
            return service.__key;
        }
        const base = service && service.sgr ? service.sgr : "service";
        return `${base}-${index}`;
    }

    normalizeIkeaServices = (services, configuration) => {
        if (!Array.isArray(services)) {
            return [];
        }
        return services.map((service, index) => {
            if (!service || typeof service !== "object") {
                return null;
            }
            const normalizedStatus = service.status || null;
            const normalizedDeviationCode = this.sanitizeDeviationCodeValue(
                normalizedStatus,
                service.deviationCode,
                configuration
            );
            const hasEstimatedHours = service.estimatedHours !== undefined && service.estimatedHours !== null;
            const parsedEstimatedHours = hasEstimatedHours ? parseFloat(service.estimatedHours) : null;
            const normalizedEstimatedHours = hasEstimatedHours && !Number.isNaN(parsedEstimatedHours)
                ? parsedEstimatedHours
                : null;
            return {
                ...service,
                status: normalizedStatus,
                deviationCode: normalizedDeviationCode || null,
                estimatedHours: normalizedEstimatedHours,
                __key: this.getIkeaServiceInternalKey(service, index)
            };
        }).filter(Boolean);
    }

    buildIkeaServicesSnapshot = (services) => {
        if (!Array.isArray(services)) {
            return [];
        }
        return services.map(service => ({
            __key: service.__key,
            ...this.getIkeaServiceComparableState(service)
        }));
    }

    getIkeaServiceComparableState = (service) => {
        if (!service) {
            return {
                status: null,
                deviationCode: null,
                estimatedHours: null
            };
        }
        const normalizedEstimatedHours = service.estimatedHours === undefined || service.estimatedHours === null
            ? null
            : service.estimatedHours;
        return {
            status: service.status || null,
            deviationCode: service.deviationCode || null,
            estimatedHours: normalizedEstimatedHours
        };
    }

    hasIkeaServiceStateData = (serviceState) => {
        if (!serviceState) {
            return false;
        }
        return !!(serviceState.status || serviceState.deviationCode || serviceState.estimatedHours !== null);
    }

    areIkeaServiceStatesEqual = (stateA, stateB) => {
        if (!stateA && !stateB) {
            return true;
        }
        if (!stateA || !stateB) {
            return false;
        }
        return stateA.status === stateB.status
            && stateA.deviationCode === stateB.deviationCode
            && stateA.estimatedHours === stateB.estimatedHours;
    }

    prepareIkeaServicePayload = (service) => {
        if (!service) {
            return null;
        }
        const { __key, deviationCode, estimatedHours, ...rest } = service;
        const normalizedEstimatedHours = estimatedHours === undefined || estimatedHours === null
            ? null
            : estimatedHours;
        const configuration = this.getCompanyConfiguration();
        const shouldIncludeAdditionalFields = this.doesStatusRequireDeviationCode(rest.status || null, configuration);
        const payload = {
            ...rest,
            status: rest.status || null
        };
        if (shouldIncludeAdditionalFields) {
            payload.deviationCode = deviationCode || null;
            payload.estimatedHours = normalizedEstimatedHours;
        } else {
            payload.deviationCode = null;
            payload.estimatedHours = null;
        }
        return payload;
    }

    getSelectedIkeaServiceKey = () => {
        const services = this.getIkeaServicesForCurrentOrder();
        if (!services.length) {
            return null;
        }
        const currentKey = this.state.selectedIkeaServiceKey;
        if (currentKey && services.some(service => service.__key === currentKey)) {
            return currentKey;
        }
        return services[0].__key;
    }

    shouldRenderEstimatedHoursAlongsideDeviation = () => {
        return this.shouldUseServiceStatusManagement();
    }

    getStatusOptionByValue = (value, optionsOverride = null) => {
        if (!value) {
            return null;
        }
        const options = optionsOverride || this.state.statusOptions || [];
        return options.find(option => option && option.value === value) || null;
    }

    getStatusLabelByValue = (value) => {
        const option = this.getStatusOptionByValue(value);
        if (option) {
            return option.label || option.value;
        }
        return value || "";
    }

    getDeviationCodeLabel = (deviationCode, configuration) => {
        if (!deviationCode) {
            return "";
        }
        const options = this.getAllDeviationCodeOptions(configuration);
        const match = options.find(option => option && option.value === deviationCode);
        return match ? (match.label || match.value) : deviationCode;
    }

    formatEstimatedHoursValue = (value) => {
        if (value === null || value === undefined) {
            return "";
        }
        return value;
    }

    formatIkeaServiceHistoryDate = (value) => {
        if (!value) {
            return "";
        }
        const parsedDate = moment(value, ["YYYY-MM-DD HH:mm:ss", moment.ISO_8601], true);
        if (!parsedDate.isValid()) {
            return value;
        }
        return parsedDate.format("YYYY-MM-DD HH:mm:ss");
    }

    getIkeaServiceHistoryEntries = (service) => {
        if (!service || !Array.isArray(service.statusHistory)) {
            return [];
        }
        return service.statusHistory.filter(item => {
            if (!item || typeof item !== "object") {
                return false;
            }
            const historyDeviationCode = item.deviationCode || item.code || null;
            const historyEstimatedHours = item.estimatedHours !== undefined ? item.estimatedHours : item.hours;
            const hasEstimatedHours = historyEstimatedHours !== null && historyEstimatedHours !== undefined;
            return !!(item.status || item.changedAt || historyDeviationCode || hasEstimatedHours);
        });
    }

    toggleIkeaServiceHistory = (serviceKey) => {
        if (!serviceKey) {
            return;
        }
        this.setState(prevState => {
            const expanded = prevState.expandedIkeaServiceHistory || {};
            return {
                expandedIkeaServiceHistory: {
                    ...expanded,
                    [serviceKey]: !expanded[serviceKey]
                }
            };
        });
    }

    updateIkeaServiceData = (serviceKey, updater, additionalState = {}) => {
        if (!serviceKey) {
            if (Object.keys(additionalState).length) {
                this.setState(additionalState);
            }
            return;
        }
        this.setState(prevState => {
            const services = Array.isArray(prevState.ikeaServices) ? prevState.ikeaServices : [];
            const updatedServices = services.map(service => {
                if (!service || service.__key !== serviceKey) {
                    return service;
                }
                const patch = typeof updater === "function" ? updater(service) : updater;
                return {
                    ...service,
                    ...patch
                };
            });
            return {
                ...additionalState,
                ikeaServices: updatedServices
            };
        });
    }

    getIkeaServicesPayload = () => {
        if (!this.shouldUseServiceStatusManagement()) {
            return null;
        }
        const services = this.getIkeaServicesForCurrentOrder();
        if (!services.length) {
            return null;
        }
        const snapshot = Array.isArray(this.state.initialIkeaServicesSnapshot) ? this.state.initialIkeaServicesSnapshot : [];
        const snapshotMap = new Map(snapshot.map(item => [item.__key, item]));
        const changedServices = services
            .map(service => {
                if (!service) {
                    return null;
                }
                const comparableState = this.getIkeaServiceComparableState(service);
                const snapshotState = snapshotMap.get(service.__key);
                if (snapshotState) {
                    if (this.areIkeaServiceStatesEqual(comparableState, snapshotState)) {
                        return null;
                    }
                    return this.prepareIkeaServicePayload(service);
                }
                return this.hasIkeaServiceStateData(comparableState)
                    ? this.prepareIkeaServicePayload(service)
                    : null;
            })
            .filter(Boolean);
        return changedServices.length ? changedServices : null;
    }

    renderDeviationCodeField = () => {
        if (!this.shouldUseServiceStatusManagement()) {
            return null;
        }
        const configuration = this.getCompanyConfiguration();
        const deviationField = this.getDeviationFieldConfiguration(configuration);
        if (!deviationField) {
            return null;
        }
        if (!this.canUseAdditionalField(deviationField)) {
            return null;
        }

        if (!this.hasDeviationCodeRules(configuration)) {
            const options = this.getAllDeviationCodeOptions(configuration);
            if (!options.length) {
                return null;
            }
            const currentValue = this.state.deviationCode || "";
            const selectedOption = options.find(option => option.value === currentValue)
                || (currentValue ? { value: currentValue, label: this.getDeviationCodeLabel(currentValue, configuration) } : null);
            const labelText = `${deviationField.label || "Kod odchylenia"}${this.requiresDeviationCode() ? " *" : ""}`;

            return (
                <fieldset key={"additional-deviationCode"}>
                    <FormGroup>
                        <ControlLabel>{labelText}:</ControlLabel>
                        <Col>
                            <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                value={selectedOption}
                                isDisabled={this.state.isPreviewOnly}
                                placeholder="Wybierz.."
                                onChange={option =>
                                    this.handleDeviationCodeChange(option)
                                }
                                options={options}
                                isClearable={true}
                            />
                        </Col>
                    </FormGroup>
                    {this.shouldRenderEstimatedHoursAlongsideDeviation() ? this.renderEstimatedHoursControl() : null}
                </fieldset>
            );
        }

        const statusValue = this.state.status ? this.state.status.value : null;
        const options = this.getDeviationCodeOptionsForStatusValue(statusValue, configuration);
        if (!options.length) {
            return null;
        }

        const currentValue = this.state.deviationCode || "";
        const selectedOption = options.find(option => option.value === currentValue)
            || (currentValue ? { value: currentValue, label: this.getDeviationCodeLabel(currentValue, configuration) } : null);
        const labelText = `${deviationField.label || "Kod odchylenia"}${this.requiresDeviationCode() ? " *" : ""}`;

        return (
            <fieldset key={"additional-deviationCode"}>
                <FormGroup>
                    <ControlLabel>{labelText}:</ControlLabel>
                    <Col>
                        <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={selectedOption}
                            isDisabled={this.state.isPreviewOnly}
                            placeholder="Wybierz.."
                            onChange={option =>
                                this.handleDeviationCodeChange(option)
                            }
                            options={options}
                            isClearable={true}
                        />
                    </Col>
                </FormGroup>
                {this.shouldRenderEstimatedHoursAlongsideDeviation() ? this.renderEstimatedHoursControl() : null}
            </fieldset>
        );
    }

    renderEstimatedHoursControl = () => {
        if (!this.shouldUseServiceStatusManagement()) {
            return null;
        }
        const fieldConfiguration = this.getAdditionalFieldConfiguration("estimatedHours");
        if (!fieldConfiguration) {
            return null;
        }
        if (!this.canUseAdditionalField(fieldConfiguration)) {
            return null;
        }
        return (
            <FormGroup>
                <ControlLabel>{fieldConfiguration.label}:</ControlLabel>
                <FormControl
                    type="number"
                    placeholder={fieldConfiguration.placeholder || "(opcjonalnie)"}
                    value={this.state.estimatedHours}
                    min={fieldConfiguration.min}
                    max={fieldConfiguration.max}
                    step={fieldConfiguration.step || "1"}
                    disabled={this.state.isPreviewOnly}
                    onChange={event =>
                        this.handleEstimatedHoursChange(event.target.value)
                    }
                />
            </FormGroup>
        );
    }

    renderIkeaServiceRow = (service, index) => {
        if (!service) {
            return null;
        }
        const key = service.__key || `ikea-service-${service.sgr || index}`;
        const statusLabel = this.getStatusLabelByValue(service.status);
        const previousStatusLabel = this.getStatusLabelByValue(service.previousStatus);
        const previousStatusDateText = this.formatIkeaServiceHistoryDate(service.previousStatusDate);
        const configuration = this.getCompanyConfiguration();
        const shouldShowAdditional = this.doesStatusRequireDeviationCode(service.status, configuration);
        const deviationLabel = shouldShowAdditional ? this.getDeviationCodeLabel(service.deviationCode, configuration) : "";
        const estimatedHoursValue = shouldShowAdditional ? this.formatEstimatedHoursValue(service.estimatedHours) : "";
        const historyEntries = this.getIkeaServiceHistoryEntries(service);
        const hasHistory = historyEntries.length > 0;
        const isHistoryExpanded = hasHistory && !!(this.state.expandedIkeaServiceHistory && this.state.expandedIkeaServiceHistory[key]);
        return (
            <div
                className="ikea-service-item"
                key={key}
                style={{ marginLeft: "16px" }}
            >
                <div className="ikea-service-name">
                    {service.name || service.sgr || `Usługa ${index + 1}`}
                    {statusLabel ? (
                        <span className="text-muted" style={{ marginLeft: "8px" }}>
                            ({statusLabel})
                        </span>
                    ) : null}
                </div>
                {shouldShowAdditional && (deviationLabel || estimatedHoursValue !== "") && (
                    <div className="text-muted small" style={{ marginTop: "4px" }}>
                        {deviationLabel && (
                            <span>
                                Kod odchylenia: <strong>{deviationLabel}</strong>
                            </span>
                        )}
                        {deviationLabel && estimatedHoursValue !== "" && (
                            <span style={{ margin: "0 6px" }}>•</span>
                        )}
                        {estimatedHoursValue !== "" && (
                            <span>
                                Szacowany czas: <strong>{estimatedHoursValue} h</strong>
                            </span>
                        )}
                    </div>
                )}
                <div className="text-muted small" style={{ marginTop: "6px" }}>
                    {hasHistory ? (
                        <button
                            type="button"
                            style={{
                                padding: 0,
                                margin: 0,
                                border: 0,
                                background: "transparent",
                                textDecoration: "none",
                                color: "#777",
                                fontSize: "12px",
                                lineHeight: "1.4",
                                boxShadow: "none"
                            }}
                            onClick={() => this.toggleIkeaServiceHistory(key)}
                        >
                            {isHistoryExpanded ? "Ukryj historię" : `Pokaż historię (${historyEntries.length})`}
                        </button>
                    ) : (
                        <span/>
                    )}
                </div>
                {isHistoryExpanded && (
                    <ul className="text-muted small" style={{ marginTop: "4px", marginBottom: 0, paddingLeft: "18px" }}>
                        {historyEntries.map((entry, historyIndex) => {
                            const entryStatusLabel = this.getStatusLabelByValue(entry.status);
                            const entryDate = this.formatIkeaServiceHistoryDate(entry.changedAt);
                            const historyDeviationCode = entry.deviationCode || entry.code || null;
                            const historyEstimatedHours = entry.estimatedHours !== undefined ? entry.estimatedHours : entry.hours;
                            const hasEstimatedHours = historyEstimatedHours !== null && historyEstimatedHours !== undefined;
                            return (
                                <li key={`${key}-history-${historyIndex}`} style={{ marginTop: "2px" }}>
                                    <strong>{entryStatusLabel || entry.status || "BRAK"}</strong>
                                    {entryDate ? ` • ${entryDate}` : ""}
                                    {historyDeviationCode ? ` • kod: ${historyDeviationCode}` : ""}
                                    {hasEstimatedHours ? ` • czas: ${historyEstimatedHours} h` : ""}
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        );
    }

    renderIkeaServicesPreview = () => {
        const services = this.getIkeaServicesForCurrentOrder();
        if (!services.length) {
            return null;
        }
        const grouped = {};
        const groupOrder = [];
        services.forEach(service => {
            const groupName = service.group || "Pozostałe";
            if (!grouped[groupName]) {
                grouped[groupName] = [];
                groupOrder.push(groupName);
            }
            grouped[groupName].push(service);
        });
        let serviceIndex = 0;
        return (
            <FormGroup className="ikea-services-preview" style={{ marginTop: "22px", marginBottom: "22px" }}>
                <ControlLabel>Usługi IKEA:</ControlLabel>
                <div className="ikea-services-list">
                    {groupOrder.map(groupName => (
                        <div
                            className="ikea-services-list-group"
                            key={groupName}
                            style={{ marginTop: "14px", marginBottom: "20px" }}
                        >
                            <div className="ikea-services-list-group-title">
                                {groupName} <span className="text-muted small">({grouped[groupName].length})</span>
                            </div>
                            {grouped[groupName].map(service => this.renderIkeaServiceRow(service, serviceIndex++))}
                        </div>
                    ))}
                </div>
            </FormGroup>
        );
    }

    renderIkeaServiceSelector = () => {
        if (!this.shouldUseServiceStatusManagement()) {
            return null;
        }
        const services = this.getIkeaServicesForCurrentOrder();
        if (!services.length) {
            return null;
        }
        const options = services.map(service => ({
            value: service.__key,
            label: service.name || service.sgr || "Usługa"
        }));
        const selectedKey = this.getSelectedIkeaServiceKey();
        const selectedOption = options.find(option => option.value === selectedKey) || null;

        return (
            <FormGroup>
                <ControlLabel>Usługa IKEA:</ControlLabel>
                <Col>
                    <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        value={selectedOption}
                        placeholder="Wybierz usługę"
                        onChange={option =>
                            this.handleIkeaServiceSelection(option ? option.value : null)
                        }
                        options={options}
                        isDisabled={this.state.isPreviewOnly}
                        isClearable={false}
                    />
                </Col>
            </FormGroup>
        );
    }

    onRefreshOrder() {
        if (this.state.orderElement) {
            this.onElementsChange(this.state.orderElement);
        }
    }

    componentDidMount() {
        let orderGuid = this.props.location.pathname.replace("/client/edit-order/", "").split('?')[0];

        if (!_api.isGuid(orderGuid)) {
            orderGuid = null;
        }

        if (this.props.uuid) {
            orderGuid = this.props.uuid;
        }

        if (orderGuid) {
            if (this.props.userHasRole(['admin', 'expertManager'])) {
                this.setState({ isAdminView: true }, () => { this.loadOrder(orderGuid); });
            } else {
                this.loadOrder(orderGuid);
            }
        } else {
            this.loadSlots(() => { });
            this.loadSchedules(() => { });

            let commonWarehouses = this.hideField("commonWarehouses") ? [] : [{ value: "pickup", label: "Odbiór od klienta" }];
            let warehouses = this.props.user.user.company.warehouses
                ? this.props.user.user.company.warehouses.map((itm) => { return { ...itm, label: itm.name, value: itm.uuid } }).concat(commonWarehouses)
                : [].concat(commonWarehouses);
            let warehouse = warehouses.length ? warehouses[0] : null;
            let warehousePlainText = warehouse ? warehouse.value : "";

            this.setState({
                orderLoading: false,
                commonWarehouses: commonWarehouses,
                warehouses: warehouses,
                warehouse: warehouse,
                warehousePlainText: warehousePlainText,
                warehouseType: warehouses.length > commonWarehouses.length ? "defined" : commonWarehouses.length ? commonWarehouses[0].value : "",
            });
        }

        window.addEventListener("ORDER_REFRESH", this.onRefreshOrder, false);
    }

    componentWillUnmount() {
        _api.abort();
        if (this.tOutSlot) {
            clearTimeout(this.tOutSlot);
        }
        this.props.setNavTitle(null);
        window.removeEventListener("ORDER_REFRESH", this.onRefreshOrder, false);
    }

    parseFloatFixed(value) {
        if (isNaN(parseFloat(value))) {
            return 0;
        }
        return parseFloat(value);
    }

    parseIntFixed(value, radix) {
        if (isNaN(parseInt(value, radix))) {
            return 0;
        }
        return parseInt(value, radix);
    }

    formatPriceValue(value) {
        return this.parseFloatFixed(value).toFixed(2);
    }

    formatMinutesValue(value) {
        if (value === null || value === undefined || value === "") {
            return "";
        }
        return this.parseIntFixed(value, 10).toString();
    }

    getElementsValueTotal(elements) {
        if (!Array.isArray(elements)) {
            return 0;
        }
        return elements.reduce((sum, element) => {
            if (!element || element.trash) {
                return sum;
            }
            return sum + this.parseFloatFixed(element.value);
        }, 0);
    }

    slotIsAvailable(slot) {
        let self = this;
        return (slot.free > 0) && (slot.free - self.state.calculatedPoints >= 0);
    }

    loadSlots(callback, holdCallback) {
        let self = this;

        let nearestDay = (moment().hour() > 17) ? 2 : 1;

        let currentDayIndex = moment().day();
        let skipDays = [];
        let keepSlot = self.state.keepSlot || "null";
        let calculatedSlotDelay = self.state.calculatedSlotDelay || 0;

        if (self.state.userOwner.company.configuration && self.state.userOwner.company.configuration.cutoff) {
            self.state.userOwner.company.configuration.cutoff.forEach(item => {
                if (!item.availableForDelivery) {
                    skipDays.push(item.day);
                }
                if (item.day === currentDayIndex) {
                    if (moment().isAfter(moment(item.cutoff, "HH:mm"))) {
                        nearestDay = 2;
                    } else {
                        nearestDay = 1;
                    }
                }
            });
        }

        if (self.state.isAdminView || this.state.express) {
            nearestDay = 0;
            skipDays = [];
        } else {
            nearestDay = nearestDay + calculatedSlotDelay;
        }

        let fromToday = moment(self.state.currentDay).add(nearestDay, 'day').format("YYYY-MM-DD");
        let tillDay = moment(self.state.currentDay).add(self.state.nextDaySpan, 'day').format("YYYY-MM-DD");

        if (self.state.isAdminView) {
            if (moment(self.state.currentDay).isAfter()) {
                fromToday = moment().format("YYYY-MM-DD");
                tillDay = moment(self.state.currentDay).add(self.state.nextDaySpan, 'day').format("YYYY-MM-DD");
            }
            if (moment(self.state.currentDay).isBefore()) {
                fromToday = moment(self.state.currentDay).format("YYYY-MM-DD");
                tillDay = moment().add(self.state.nextDaySpan, 'day').format("YYYY-MM-DD");
            }
        }

        _api.request(`/slot/list/${self.state.department}/${fromToday}/${tillDay}/${keepSlot}`, {},
            (data) => {

                let slotsMapping = {};
                let availableSlots = [];

                for (let i = 0; i < data.length; i++) {
                    slotsMapping[data[i].uuid] = data[i];
                }

                let removeSelectedSlot = true;

                for (let i = 0; i < data.length; i++) {
                    let slot = data[i];
                    let labelDay = moment(slot.dayIdent).format("DD.MM.YYYY (dddd)");
                    let realUsed = slot.size - slot.free;
                    let capacity = self.state.isAdminView && !self.state.isPreviewOnly ? "(" + realUsed + " / " + slot.size + ")" : "";
                    let labelHour = slot.dayPart;
                    let includeSlot = false;

                    if (self.props.includeUnavailableSlots || self.state.isAdminView || self.state.isPreviewOnly) {
                        includeSlot = true;
                    } else if (self.state.keepSlot && self.state.keepSlot === slot.uuid) {
                        includeSlot = true;
                    } else if (skipDays.includes(moment(slot.dayIdent).day())) {
                        includeSlot = false;
                    } else if (self.slotIsAvailable(slot)) {
                        if (_.includes(self.state.userOwner.company.configuration.spans, slot.dayPart)) {
                            includeSlot = true;
                        }
                    }
                    if (includeSlot) {
                        availableSlots.push({
                            "value": slot.uuid,
                            "label": labelDay + " " + labelHour + " " + capacity,
                            "free": slot.free,
                            "day": slot.dayIdent
                        });
                        if (self.state.slot && self.state.slot.value) {
                            if (slot.uuid === self.state.slot.value) {
                                removeSelectedSlot = false;
                            }
                        }
                    }
                }

                if (self.state.slot && self.state.slot.value) {
                    if (removeSelectedSlot) {
                        self.props.showNoty('tr', 'error', 'Musisz wybrać inny termin dostawy, nastąpił cut-off');
                        self.setState({ slot: null });
                    }
                }

                self.setState({ availableSlots: availableSlots }, () => { callback() });

                if (!self.state.isAdminView && !self.state.isPreviewOnly) {
                    self.tOutSlot = setTimeout(() => {
                        if (holdCallback) {
                            self.loadSlots(() => { })
                        } else {
                            self.loadSlots(() => { callback() })
                        }
                    }, 5 * 1000);
                }

            },
            (error) => {
                self.props.showNoty('tr', 'error', 'Wystąpił błąd podczas pobierania danych');
            }
        );
    }

    loadSchedules(callback) {
        let self = this;

        let fromToday = moment(this.state.currentDay).add(1, 'day').format("YYYY-MM-DD");
        let tillDay = moment(this.state.currentDay).add(this.state.nextDaySpan, 'day').format("YYYY-MM-DD");

        if (self.state.isAdminView) {
            if (moment(self.state.currentDay).isAfter()) {
                fromToday = moment().format("YYYY-MM-DD");
                tillDay = moment(self.state.currentDay).add(self.state.nextDaySpan, 'day').format("YYYY-MM-DD");
            }
            if (moment(self.state.currentDay).isBefore()) {
                fromToday = moment(self.state.currentDay).format("YYYY-MM-DD");
                tillDay = moment().add(self.state.nextDaySpan, 'day').format("YYYY-MM-DD");
            }
        }

        _api.request(`/schedule/list/${this.state.department}/${fromToday}/${tillDay}/true/${self.state.keepSchedule}`, {},
            (data) => {
                let tempArray = [];
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        tempArray.push({ "value": data[i].uuid, "label": data[i].ident });
                    }
                }
                self.setState({ availableSchedule: tempArray }, () => { callback() });
            },
            (error) => {
                self.props.showNoty('tr', 'error', 'Wystąpił błąd podczas pobierania danych');
            }
        );
    }

    loadOrder(orderUuid) {
        let self = this;
        self.setState({ uuid: orderUuid, orderLoading: true });
        _api.request(`/order/details/${orderUuid}`, {},
            (data) => {
                let isPreviewOnly = self.state.isPreviewOnly;
                if (isPreviewOnly) {
                    if (data.slot.uuid) {
                        isPreviewOnly = true;
                    } else {
                        isPreviewOnly = false;
                    }
                }
                // odblokowanie możliwości edycji dla osób bez admina
                if (!self.state.isAdminView) {
                    isPreviewOnly = false;
                }

                const lockState = data.order.lockState || "open";
                const canBypass = data.canEditLockedOrders;

                if (canBypass) {
                    if (lockState === "locked") {
                        isPreviewOnly = true;
                    }
                } else {
                    if (lockState !== "open") {
                        isPreviewOnly = true;
                    }
                }
                // ---
                const isIkeaOrder = isIkeaCompany(data.realUserCompany);
                const companyConfiguration = data.user && data.user.company ? data.user.company.configuration : null;
                const rawEstimatedHours = data.order.ikeaEstimatedHours !== undefined ? data.order.ikeaEstimatedHours : data.order.estimatedHours;
                const estimatedHours = (rawEstimatedHours === null || rawEstimatedHours === undefined) ? "" : rawEstimatedHours;
                const requestedDeviationCode = data.order.ikeaDeviationCode || data.order.deviationCode || "";
                const statusName = data.order.status && data.order.status.name ? data.order.status.name : null;
                const normalizedStatusName = statusName ? statusName.toLowerCase() : null;
                const statusOptions = self.getStatusOptions(isIkeaOrder, companyConfiguration);
                const orderStatusOptions = self.getStatusOptions(false, companyConfiguration);
                const statusFromOptions = normalizedStatusName ? statusOptions.find(itm => (itm.value || "").toLowerCase() === normalizedStatusName) : null;
                const orderStatusFromOptions = normalizedStatusName ? orderStatusOptions.find(itm => (itm.value || "").toLowerCase() === normalizedStatusName) : null;
                const sanitizedDeviationCode = self.sanitizeDeviationCodeValue(statusFromOptions ? statusFromOptions.value : null, requestedDeviationCode, companyConfiguration);
                const ikeaServicesDetails = self.getIkeaServiceDetails(data);
                let normalizedIkeaServices = self.normalizeIkeaServices(ikeaServicesDetails, companyConfiguration);
                const hasServiceStatuses = normalizedIkeaServices.length > 0;
                const initialServiceKey = hasServiceStatuses ? normalizedIkeaServices[0].__key : null;
                const initialService = hasServiceStatuses ? normalizedIkeaServices.find(service => service.__key === initialServiceKey) : null;
                const serviceStatusOption = initialService
                    ? (
                        self.getStatusOptionByValue(initialService.status, statusOptions)
                        || (initialService.status ? { value: initialService.status, label: initialService.status } : null)
                    )
                    : null;
                const statusToUse = hasServiceStatuses ? (serviceStatusOption || statusFromOptions || null) : (statusFromOptions || null);
                let deviationCodeToUse = hasServiceStatuses
                    ? self.sanitizeDeviationCodeValue(statusToUse ? statusToUse.value : null, initialService ? initialService.deviationCode : "", companyConfiguration)
                    : sanitizedDeviationCode;
                const estimatedHoursToUse = hasServiceStatuses
                    ? self.formatEstimatedHoursValue(initialService ? initialService.estimatedHours : "")
                    : estimatedHours;
                if (hasServiceStatuses && initialService && deviationCodeToUse !== (initialService.deviationCode || "")) {
                    normalizedIkeaServices = normalizedIkeaServices.map(service => {
                        if (!service || service.__key !== initialService.__key) {
                            return service;
                        }
                        return {
                            ...service,
                            deviationCode: deviationCodeToUse || null
                        };
                    });
                }
                const ikeaServicesSnapshot = self.buildIkeaServicesSnapshot(normalizedIkeaServices);

                self.setState(
                    {
                        userOwner: data.user,
                        department: data.department.uuid || data.user.department.uuid,
                        currentDay: data.slot.dayIdent ? moment(data.slot.dayIdent) : moment(),
                        payerOptions: data.user.company.configuration.order.payment.payer,
                        isPreviewOnly: isPreviewOnly,
                        keepSlot: data.slot.uuid,
                        keepSchedule: data.schedule.uuid
                    },
                    () => {
                        self.loadSlots(
                            () => {
                                self.loadSchedules(
                                    () => {
                                        self.props.setNavTitle(`Edytuj zlecenie - ${data.order.ident}`);
                                        let payer = self.state.payerOptions.filter(itm => itm.value === data.order.payer)[0];
                                        let warehouses = data.user.company.warehouses ? data.user.company.warehouses.map((itm) => { return { ...itm, label: itm.name, value: itm.uuid } }) : [];
                                        warehouses = warehouses.concat(this.state.commonWarehouses);

                                        self.setState(
                                            {
                                                uuid: data.order.uuid,
                                                ident: data.order.ident,
                                                status: statusToUse || null,
                                                orderStatus: orderStatusFromOptions || statusFromOptions || null,
                                                estimatedHours: estimatedHoursToUse,
                                                deviationCode: deviationCodeToUse,
                                                trash: data.order.trash || false,
                                                cod: data.order.cod || "",
                                                settled: data.order.settled || false,
                                                wasSettled: data.order.settled || false,
                                                express: data.order.express || false,
                                                transferable: data.order.transferable || false,
                                                delayRequest: data.order.delayRequest || false,
                                                withoutDelivery: data.order.withoutDelivery || false,
                                                allowNoBringing: data.order.allowNoBringing || false,
                                                releaseElements: data.order.releaseElements || false,
                                                serviceType: data.order.serviceType || "",
                                                identExternal: data.order.identExternal || "",
                                                identExternalVoucher: data.order.identExternalVoucher || "",
                                                discountValue: data.order.discountValue || "",
                                                name: data.address.name || "",
                                                streetNumber: data.address.streetNumber || "",
                                                streetAddress: data.address.streetAddress || "",
                                                cityName: data.address.cityName || "",
                                                postalCode: data.address.postalCode || "",
                                                apartmentNumber: data.address.apartmentNumber || "",
                                                apartmentFloor: data.address.apartmentFloor || "",
                                                elevator: data.address.elevator,
                                                contactPerson: data.address.contactPerson || "",
                                                emailAddress: data.address.emailAddress || "",
                                                mobilePhone: data.address.mobilePhone || "",
                                                geoLat: data.address.geoLat,
                                                geoLng: data.address.geoLng,
                                                payer: payer,
                                                paymentType: payer && payer.paymentType ? payer.paymentType.filter(itm => itm.value === data.order.paymentType)[0] : null,
                                                type: self.state.availableTypes.filter(itm => itm.value === data.order.type)[0],
                                                slot: self.state.availableSlots.filter(itm => itm.value === data.slot.uuid)[0],
                                                schedule: self.state.availableSchedule.filter(itm => itm.value === data.schedule.uuid)[0],
                                                comment: data.order.comment || "",
                                                commentFleet: data.order.commentFleet || "",
                                                commentExpert: data.order.commentExpert || "",
                                                orderService: data.service || [],
                                                orderElement: data.element || [],
                                                eInvoice: data.eInvoice || false,
                                                currentFiles: data.file || [],
                                                availableServices: data.user.company.service || [],
                                                children: data.order.children || [],
                                                calculatedZone: data.order.zone,
                                                calculatedDistance: data.order.calculatedDistance,
                                                calculatedWeight: data.order.calculatedWeight || 0,
                                                calculatedSize: data.order.calculatedSize || 0,
                                                calculatedPriceClient: data.order.calculatedPriceClient,
                                                ikeaAssemblyTimeTotalMinutes: data.order.ikeaAssemblyTimeTotalMinutes,
                                                ikeaSumNetValue: data.order.ikeaSumNetValue,
                                                manualPriceClient: isIkeaOrder ? true : !!data.order.manualPriceClient,
                                                calculatedPriceFleet: data.order.calculatedPriceFleet,
                                                calculatedPriceAssembler: data.order.calculatedPriceAssembler,
                                                calculatedPriceReal: data.order.calculatedPriceReal,
                                                calculatedPoints: data.order.calculatedPoints,
                                                lockState: lockState,
                                                canEditLockedOrders: canBypass,
                                                warehouses: warehouses,
                                                warehouse: warehouses.filter(itm => data.order.warehouse ? itm.value === data.order.warehouse.uuid : itm.value === data.order.warehouseType)[0],
                                                warehouseType: data.order.warehouseType || "other",
                                                warehousePlainText: data.address.warehouse || data.order.warehouse?.name || "",
                                                isLoading: false,
                                                orderLoading: false,

                                                lastMileWarehouseName: data.lastMileWarehouseAddress.name || "",
                                                lastMileWarehouseStreetNumber: data.lastMileWarehouseAddress.streetNumber || "",
                                                lastMileWarehouseStreetAddress: data.lastMileWarehouseAddress.streetAddress || "",
                                                lastMileWarehouseCityName: data.lastMileWarehouseAddress.cityName || "",
                                                lastMileWarehousePostalCode: data.lastMileWarehouseAddress.postalCode || "",
                                                lastMileWarehouseaPartmentNumber: data.lastMileWarehouseAddress.apartmentNumber || "",
                                                lastMileWarehouseaPartmentFloor: data.lastMileWarehouseAddress.apartmentFloor || "",
                                                lastMileWarehouseElevator: data.lastMileWarehouseAddress.elevator,
                                                lastMileWarehouseContactPerson: data.lastMileWarehouseAddress.contactPerson || "",
                                                lastMileWarehouseEmailAddress: data.lastMileWarehouseAddress.emailAddress || "",
                                                lastMileWarehouseMobilePhone: data.lastMileWarehouseAddress.mobilePhone || "",
                                                lastMileWarehouseGeoLat: data.lastMileWarehouseAddress.geoLat,
                                                lastMileWarehouseGeoLng: data.lastMileWarehouseAddress.geoLng,
                                                calculateDeliveryFromWarehouse: data.order.calculateDeliveryFromWarehouse,
                                                isIkeaOrder: isIkeaOrder,
                                                statusOptions: statusOptions,
                                                realUserCompanyName: data.realUserCompany.name,
                                                lastMileWarehouseCompanyUuid: data.lastMileWarehouseCompany.uuid,
                                                ikeaServices: normalizedIkeaServices,
                                                selectedIkeaServiceKey: hasServiceStatuses ? initialServiceKey : null,
                                                initialIkeaServicesSnapshot: ikeaServicesSnapshot,
                                                expandedIkeaServiceHistory: {}
                                            },
                                            () => {
                                                self.setDistance(data.order.calculatedDistance, () => {
                                                    self.buildFullAddress(() => {
                                                        setTimeout((self) => {
                                                            self.onRefreshOrder();
                                                            window.dispatchEvent(new CustomEvent('ORDER_LOADED', { 'detail': {} }), true);
                                                        }, 250, this);
                                                    });
                                                });
                                            }
                                        );
                                    }
                                );
                            },
                            true
                        );
                    }
                );
            },
            (error) => {
                self.setState({ isLoading: false, orderLoading: false });
                self.props.showNoty('tr', 'error', 'Wystąpił błąd podczas pobierania danych');
            },
            (progress) => {
                self.props.setProgress(progress);
            }
        );
    }

    buildFullAddress(callback) {

        let {
            postalCode,
            cityName,
            streetAddress,
            streetNumber,
        } = this.state;

        let allParts = (postalCode && cityName && streetAddress && streetNumber) ? true : false;
        let fullAddress = '';
        if (allParts) {
            fullAddress = `${streetAddress} ${streetNumber}, ${postalCode} ${cityName}`;
            if (!cityName?.includes(',')) {
                fullAddress = `${fullAddress}, Polska`;
            }
        }
        this.setState({ fullAddress: fullAddress }, callback);
    }

    setAddress = (data) => {
        const postalCodeChanged = Object.prototype.hasOwnProperty.call(data, "postalCode")
            && data.postalCode !== this.state.postalCode;
        this.setState(data, () => {
            this.buildFullAddress();
            if (postalCodeChanged) {
                this.calculateAll();
            }
        });
    }

    handleAdditionalFilesSelected = (files) => {
        this.setState({ additionalFiles: files });
    }

    handleAdditionalFilesValidationError = ({ invalidFiles, acceptedExtensions }) => {
        if (!Array.isArray(invalidFiles) || !invalidFiles.length) {
            return;
        }
        const invalidFileNames = invalidFiles.map(file => file && file.name).filter(Boolean);
        const invalidFileNamesLabel = invalidFileNames.length ? ` (${invalidFileNames.join(", ")})` : "";
        this.props.showNoty(
            "tr",
            "error",
            `Dla zleceń IKEA dozwolone są tylko pliki: ${acceptedExtensions.join(", ")}${invalidFileNamesLabel}`
        );
    }

    handleStatusChange = (value) => {
        const statusValue = value ? value.value : null;
        const configuration = this.getCompanyConfiguration();
        const sanitizedDeviationCode = this.sanitizeDeviationCodeValue(statusValue, this.state.deviationCode, configuration);
        if (this.shouldUseServiceStatusManagement()) {
            const selectedKey = this.getSelectedIkeaServiceKey();
            const shouldIncludeAdditionalFields = this.doesStatusRequireDeviationCode(statusValue, configuration);
            this.updateIkeaServiceData(
                selectedKey,
                service => ({
                    status: statusValue,
                    deviationCode: shouldIncludeAdditionalFields ? (sanitizedDeviationCode || null) : null,
                    estimatedHours: shouldIncludeAdditionalFields ? service.estimatedHours : null
                }),
                {
                    status: value,
                    deviationCode: shouldIncludeAdditionalFields ? sanitizedDeviationCode : "",
                    estimatedHours: shouldIncludeAdditionalFields ? this.state.estimatedHours : ""
                }
            );
        } else {
            this.setState({
                status: value,
                orderStatus: value,
                deviationCode: sanitizedDeviationCode
            });
        }
    }

    handleOrderStatusChange = (value) => {
        if (this.shouldUseServiceStatusManagement()) {
            this.setState({ orderStatus: value });
            return;
        }
        this.setState({
            orderStatus: value,
            status: value
        });
    }

    handleDeviationCodeChange = (option) => {
        const deviationCodeValue = option ? option.value : "";
        if (this.shouldUseServiceStatusManagement()) {
            const selectedKey = this.getSelectedIkeaServiceKey();
            this.updateIkeaServiceData(
                selectedKey,
                { deviationCode: deviationCodeValue || null },
                { deviationCode: deviationCodeValue }
            );
        } else {
            this.setState({ deviationCode: deviationCodeValue });
        }
    }

    handleEstimatedHoursChange = (value) => {
        if (this.shouldUseServiceStatusManagement()) {
            const selectedKey = this.getSelectedIkeaServiceKey();
            const parsedValue = value === "" ? null : parseFloat(value);
            const normalizedValue = parsedValue === null || Number.isNaN(parsedValue) ? null : parsedValue;
            this.updateIkeaServiceData(
                selectedKey,
                { estimatedHours: normalizedValue },
                { estimatedHours: value }
            );
        } else {
            this.setState({ estimatedHours: value });
        }
    }

    handleIkeaServiceSelection = (serviceKey) => {
        const services = this.getIkeaServicesForCurrentOrder();
        if (!services.length) {
            this.setState({
                selectedIkeaServiceKey: null,
                status: null,
                deviationCode: "",
                estimatedHours: ""
            });
            return;
        }
        const nextKey = serviceKey || services[0].__key;
        const selectedService = services.find(service => service.__key === nextKey) || null;
        const statusOption = selectedService
            ? (
                this.getStatusOptionByValue(selectedService.status)
                || (selectedService.status ? { value: selectedService.status, label: selectedService.status } : null)
            )
            : null;
        const sanitizedDeviationCode = this.sanitizeDeviationCodeValue(
            statusOption ? statusOption.value : null,
            selectedService ? selectedService.deviationCode : "",
            this.getCompanyConfiguration()
        );
        const estimatedHoursValue = this.formatEstimatedHoursValue(selectedService ? selectedService.estimatedHours : "");
        let ikeaServicesUpdate = null;
        if (selectedService && sanitizedDeviationCode !== (selectedService.deviationCode || "")) {
            ikeaServicesUpdate = services.map(service => {
                if (!service || service.__key !== selectedService.__key) {
                    return service;
                }
                return {
                    ...service,
                    deviationCode: sanitizedDeviationCode || null
                };
            });
        }
        this.setState({
            selectedIkeaServiceKey: nextKey,
            status: statusOption || null,
            deviationCode: sanitizedDeviationCode,
            estimatedHours: estimatedHoursValue,
            ...(ikeaServicesUpdate ? { ikeaServices: ikeaServicesUpdate } : {})
        });
    }

    onDirectionsChange = (data) => {
        this.setState({ geoLat: data.destinationGeoLat, geoLng: data.destinationGeoLng }, () => {
            this.setDistance(data.distance);
        });
    }

    onDirectionsNotFound = (data) => {
        this.props.showNoty('tr', 'error', 'Podany adres nie został znaleziony');
        this.setState({ fullAddress: '', geoLat: '', geoLng: '' });
    }

    setDistance = (distance, callback) => {
        if (!this.state.userOwner.company.zone) {
            this.props.showNoty('tr', 'error', 'Brak zdefiniowanych stref!!');
            return;
        }
        this.setState({ calculatedDistance: distance }, () => { this.calculateAll(callback); });
    }

    manageService(service, checked, autoRequired) {
        if (!this.state.calculatedDistance) {
            this.props.showNoty('tr', 'error', 'Najpierw zdefiniuj adres dostawy');
            return;
        }
        if (checked) {
            this.setState({
                orderService: this.state.orderService.concat([{ "uuid": service, "quantity": 1, "autoRequired": autoRequired }])
            }, () => { this.calculateAll(); });
        } else {
            this.setState({
                orderService: this.state.orderService.filter(item => { return item.uuid !== service })
            }, () => { this.calculateAll(); });
        }
    }

    manageServiceQuantity(serviceUuid, quantity) {
        if (!this.state.calculatedDistance) {
            this.props.showNoty('tr', 'error', 'Najpierw zdefiniuj adres dostawy');
            return;
        }
        quantity = this.parseIntFixed(quantity, 10);
        if (Number.isNaN(quantity)) {
            quantity = 1;
        }
        const newServices = this.state.orderService.map((service) => {
            if (serviceUuid !== service.uuid) return service;
            let updatedService = { ...service };
            updatedService['quantity'] = quantity;
            return updatedService;
        });
        this.setState({
            orderService: newServices
        }, () => { this.calculateAll(); });
    }

    calculateAll(callback) {

        let distanceLeft = this.state.calculatedDistance;
        let weightLeft = this.state.calculatedWeight;
        let department = this.state.department;
        let clientPrice = 0;
        let fleetPrice = 0;
        let assemblerPrice = 0;
        let realPrice = 0;
        let points = 0;
        let selectedIndex = -1;
        let selectedZone = null;
        let slotDelay = 0;

        if (!this.state.userOwner.company.zone) {
            this.props.showNoty('tr', 'error', 'Brak zdefiniowanych stref dostaw!!');
            return;
        }

        if (this.state.userOwner.company.configuration.zones.mode === "perimeter") {
            for (let i = 0; i < this.state.userOwner.company.zone.length; i++) {
                let currentZone = this.state.userOwner.company.zone[i];
                let perimeter = this.parseFloatFixed(currentZone.perimeter);
                let alreadyUsed = i ? this.parseFloatFixed(this.state.userOwner.company.zone[i - 1].perimeter) : 0;
                let basis;

                if (this.state.calculatedDistance > perimeter) {
                    distanceLeft -= (perimeter - alreadyUsed);
                    basis = (perimeter - alreadyUsed);
                } else {
                    selectedIndex = i;
                    basis = distanceLeft;
                }

                if (this.state.withoutDelivery === false) {
                    clientPrice += this.parseFloatFixed(basis) * this.parseFloatFixed(currentZone.perimeterPriceClient);
                    fleetPrice += this.parseFloatFixed(basis) * this.parseFloatFixed(currentZone.perimeterPriceFleet);
                    assemblerPrice += this.parseFloatFixed(basis) * this.parseFloatFixed(currentZone.perimeterPriceAssembler);
                    realPrice += this.parseFloatFixed(basis) * this.parseFloatFixed(currentZone.perimeterPriceReal);
                }

                if (selectedIndex !== -1) {
                    break;
                }
            }
        }

        else if (this.state.userOwner.company.configuration.zones.mode === "weightPostalCode") {
            for (let i = 0; i < this.state.userOwner.company.zone.length; i++) {
                let currentZone = this.state.userOwner.company.zone[i];
                let maxWeight = this.parseFloatFixed(currentZone.weight);

                if (weightLeft <= maxWeight) {
                    if (currentZone.postalCode.includes(this.state.postalCode)) {
                        selectedIndex = i;
                    }
                }

                if (selectedIndex !== -1) {
                    break;
                }
            }
        }

        else if (this.state.userOwner.company.configuration.zones.mode === "postalCodeOnly") {
            for (let i = 0; i < this.state.userOwner.company.zone.length; i++) {
                let currentZone = this.state.userOwner.company.zone[i];
                if (currentZone.postalCode.includes(this.state.postalCode)) {
                    selectedIndex = i;
                }
                if (selectedIndex !== -1) {
                    break;
                }
            }
        }

        if (selectedIndex === -1) {
            this.props.showNoty('tr', 'error', 'Podany adres wykracza poza strefy dostaw');
            this.setState(
                {
                    calculatedZone: null,
                    calculatedZoneData: null,
                    calculatedPriceClient: (this.state.manualPriceClient) ? this.state.calculatedPriceClient : clientPrice,
                    calculatedPriceFleet: fleetPrice,
                    calculatedPriceAssembler: assemblerPrice,
                    calculatedPriceReal: realPrice,
                    calculatedPoints: points
                },
                callback
            );
            return;
        }

        if (this.state.discountValue) {
            clientPrice -= this.parseFloatFixed(this.state.discountValue);
        }

        selectedZone = this.state.userOwner.company.zone[selectedIndex];
        points = this.parseIntFixed(selectedZone.points, 10);
        slotDelay = this.parseIntFixed(selectedZone.slotDelay, 10);

        if (this.state.withoutDelivery === false) {
            clientPrice += this.parseFloatFixed(selectedZone.basePriceClient);
            fleetPrice += this.parseFloatFixed(selectedZone.basePriceFleet);
            realPrice += this.parseFloatFixed(selectedZone.basePriceReal);
        }

        if (selectedZone.lastMileWarehouse.department?.uuid) {
            department = selectedZone.lastMileWarehouse.department?.uuid;
        }

        if (this.state.availableServices && this.state.availableServices.length) {
            for (let i = 0; i < this.state.availableServices.length; i++) {
                if (this.state.orderService.some(s => s.uuid === this.state.availableServices[i].uuid)) {
                    let orderServiceParams = this.state.orderService.find(s => s.uuid === this.state.availableServices[i].uuid);
                    let serviceQuantity = this.parseIntFixed(orderServiceParams.quantity, 10);
                    if (orderServiceParams.autoRequired && this.state.allowNoBringing) {
                        clientPrice += this.parseFloatFixed(this.state.availableServices[i].fallbackPriceReal) * serviceQuantity;
                        fleetPrice += this.parseFloatFixed(this.state.availableServices[i].fallbackPriceReal) * serviceQuantity;
                        assemblerPrice += this.parseFloatFixed(this.state.availableServices[i].fallbackPriceReal) * serviceQuantity;
                        realPrice += this.parseFloatFixed(this.state.availableServices[i].fallbackPriceReal) * serviceQuantity;
                    } else {
                        clientPrice += this.parseFloatFixed(this.state.availableServices[i].basePriceClient) * serviceQuantity;
                        fleetPrice += this.parseFloatFixed(this.state.availableServices[i].basePriceFleet) * serviceQuantity;
                        assemblerPrice += this.parseFloatFixed(this.state.availableServices[i].basePriceAssembler) * serviceQuantity;
                        realPrice += this.parseFloatFixed(this.state.availableServices[i].basePriceReal) * serviceQuantity;
                    }
                    points += this.parseIntFixed(this.state.availableServices[i].points, 10) * serviceQuantity;
                }
            }
        }

        const activeOrderElements = this.state.orderElement.filter(element => !element.trash);
        if (this.state.type?.value === "assembly" && activeOrderElements.length) {
            for (let i = 0; i < activeOrderElements.length; i++) {
                if (activeOrderElements[i].value && activeOrderElements[i].percentStakeAssembler) {
                    assemblerPrice += this.parseFloatFixed(activeOrderElements[i].value) * (this.parseIntFixed(activeOrderElements[i].percentStakeAssembler, 10) * 0.01);
                }
            }

            if (assemblerPrice < 100) { // minumum stake for assembly
                assemblerPrice = 100;
            }

            assemblerPrice += this.parseFloatFixed(selectedZone.basePriceAssembler);

            clientPrice = assemblerPrice;
        }

        if (this.state.realUserCompanyName === 'MediaMarkt [NET]') {
            _api.request(`/order/perimeter-rates/${this.state.lastMileWarehouseCompanyUuid}/${distanceLeft}`,
                {},
                (data) => {
                    clientPrice += this.parseFloatFixed(data.prices.priceClient);
                    fleetPrice += this.parseFloatFixed(data.prices.priceFleet);
                    realPrice += this.parseFloatFixed(data.prices.priceReal);
                    points += this.parseIntFixed(data.points);
                },
                (error) => {
                    this.props.showNoty('tr', 'error', 'Błąd podczas wczytywania danych');
                },
                () => {},
                'GET',
                false
            );
        }

        this.setState({
            calculatedZone: selectedZone.name,
            calculatedZoneData: selectedZone,
            calculatedSlotDelay: slotDelay,
            calculatedPriceClient: (this.state.manualPriceClient) ? this.state.calculatedPriceClient : Math.round(this.parseFloatFixed(clientPrice)).toFixed(2),
            calculatedPriceFleet: Math.round(this.parseFloatFixed(fleetPrice)).toFixed(2),
            calculatedPriceAssembler: Math.round(this.parseFloatFixed(assemblerPrice)).toFixed(2),
            calculatedPriceReal: this.parseFloatFixed(realPrice).toFixed(2),
            calculatedPoints: points,
            department: department,
        }, callback);

    }

    validateDelayRequest(callback, verify) {

        // https://3.basecamp.com/4403908/buckets/15514837/todos/3556902786

        if (!this.state.userOwner.company.configuration.order.additionalFields.delayRequest) {
            callback();
            return true;
        }

        if (!this.state.slot) {
            callback();
            return true;
        }

        if (this.state.type?.value === "assembly") {
            callback();
            return true;
        }

        let nowDate = moment();
        let before18 = moment().isBefore(moment("18:00", "HH:mm"));
        let thenDate = moment(this.state.slot.day);
        let theDiff = thenDate.diff(nowDate, 'days') + 1;
        let maxDaySpan = 0;

        switch (nowDate.day()) {

            case 0: // niedziela
                if (before18) {
                    maxDaySpan = 2;
                } else {
                    maxDaySpan = 3;
                }
                break;

            case 1: // poniedziałek
                if (before18) {
                    maxDaySpan = 2;
                } else {
                    maxDaySpan = 3;
                }
                break;

            case 2: // wtorek
                if (before18) {
                    maxDaySpan = 2;
                } else {
                    maxDaySpan = 3;
                }
                break;


            case 3: // środa
                if (before18) {
                    maxDaySpan = 2;
                } else {
                    maxDaySpan = 3;
                }
                break;

            case 4: // czwartek
                if (before18) {
                    maxDaySpan = 2;
                } else {
                    maxDaySpan = 4;
                }
                break;

            case 5: // piątek
                if (before18) {
                    maxDaySpan = 3;
                } else {
                    maxDaySpan = 4;
                }
                break;

            case 6: // sobota
                if (before18) {
                    maxDaySpan = 3;
                } else {
                    maxDaySpan = 4;
                }
                break;

            default: // default
                maxDaySpan = 3;
                break;
        }

        // https://3.basecamp.com/4403908/buckets/15514837/todos/3745008560

        if (theDiff <= maxDaySpan) {
            if (this.state.delayRequest) {
                this.props.showNoty('tr', 'error', 'Musisz odznaczyć opcję "Termin na życzenie klienta"');
                return false;
            }
            callback();
            return true;
        }

        // https://3.basecamp.com/4403908/buckets/15514837/todos/4161888313#__recording_4161903050
        else {
            verify(callback);
            return true;
        }

        /*
        else if (theDiff <= maxDaySpan + 2) {
            verify(callback);
            return true;
        }

        else { // theDiff > maxDaySpan + 2
            if (!this.state.delayRequest) {
                this.props.showNoty('tr', 'error', 'Musisz zaznaczyć opcję "Termin na życzenie klienta"');
                return false;
            }
            callback();
            return true;
        }
        */

    }

    saveData() {
        let self = this;
        self.setState({ isLoading: true });

        if (self.state.isPreviewOnly) {
            self.props.showNoty('tr', 'info', 'Aktualizacja danych podstawowych..');
            _api.request(`/order/postprocessing/${self.state.uuid}`,
                {
                    "order": {
                        "comment": self.state.comment
                    }
                },
                (data) => {
                    self.setState({ isLoading: false });
                    self.props.showNoty('tr', 'success', 'Dane zostały zaktualizowane..');
                },
                (error) => {
                    self.setState({ isLoading: false });
                    self.props.showNoty('tr', 'error', 'Wystąpił błąd podczas zapisu');
                },
                (progress) => {
                    self.props.setProgress(progress);
                }
            );
            return;
        }

        let validationRules = {
            "isValid": true,
            "items": [
                { "field": "name", "rules": { "empty": "Uzupełnij nazwę odbiorcy" } },
                { "field": "streetAddress", "rules": { "empty": "Uzupełnij ulicę, numer domu i miasto" } },
                { "field": "mobilePhone", "rules": { "empty": "Uzupełnij numer telefonu" } },
                { "field": "payer", "rules": { "empty": "Wybierz rodzaj płatności" } },
                { "field": "calculatedDistance", "rules": { "empty": "Zweryfikuj adres dostawy (dystans nie został obliczony)" } },
                { "field": "calculatedZone", "rules": { "empty": "Zweryfikuj adres dostawy (strefa nie została przypisana)" } },
                { "field": "calculatedPriceClient", "rules": { "empty": "Zweryfikuj dane (kwota nie została obliczona)" } },
            ]
        };

        if (!self.hideField("warehouse")) {
            validationRules.items.push({ "field": "warehouse", "rules": { "empty": "Podaj magazyn" } })
            validationRules.items.push({ "field": "warehousePlainText", "rules": { "empty": "Podaj magazyn" } })
        }

        if (self.state.userOwner.company.configuration.order.additionalValidation) {
            validationRules.items.concat(self.state.userOwner.company.configuration.order.additionalValidation);
        }

        validationRules.items.forEach(element => {
            if (!validationRules.isValid) {
                return;
            } else {
                let elementValue = self.state[element.field];
                if ("empty" in element.rules && (elementValue === "" || elementValue === null || elementValue === undefined)) {
                    validationRules.isValid = false;
                    self.props.showNoty('tr', 'error', element.rules.empty);
                }
            }
        });

        if (!validationRules.isValid) {
            self.setState({ isLoading: false });
            return;
        }

        if (!self.validateDeviationCodesBeforeSave()) {
            self.setState({ isLoading: false });
            return;
        }

        const statusForOrder = self.shouldUseServiceStatusManagement()
            ? (self.state.orderStatus ? self.state.orderStatus.value : null)
            : (self.state.status ? self.state.status.value : null);
        const ikeaServicesPayload = self.getIkeaServicesPayload();

        self.props.showNoty('tr', 'info', 'Zapisywanie zlecenia..');

        let endpoint = self.state.uuid ? `/order/update/${self.state.uuid}` : `/order/create`;

        const requestPayload = {
            "files": self.state.additionalFiles,
            "order": {
                "identExternal": self.state.identExternal,
                "identExternalVoucher": self.state.identExternalVoucher,
                "discountValue": self.state.discountValue,
                "type": self.state.type ? self.state.type?.value : null,
                "status": statusForOrder,
                "payer": self.state.payer ? self.state.payer.value : null,
                "comment": self.state.comment,
                "cod": self.state.cod,
                "express": self.state.express,
                "transferable": self.state.transferable,
                "lockState": self.state.lockState,
                "settled": self.state.settled,
                "delayRequest": self.state.delayRequest,
                "withoutDelivery": self.state.withoutDelivery,
                "allowNoBringing": self.state.allowNoBringing,
                "releaseElements": self.state.releaseElements,
                "trash": self.state.trash,
                "calculatedPriceClient": self.state.calculatedPriceClient,
                "manualPriceClient": self.state.manualPriceClient,
                "calculatedPriceFleet": self.state.calculatedPriceFleet,
                "calculatedPriceAssembler": self.state.calculatedPriceAssembler,
                "calculatedPriceReal": self.state.calculatedPriceReal,
                "calculatedPoints": self.state.calculatedPoints,
                "calculatedDistance": self.state.calculatedDistance,
                "calculatedWeight": self.state.calculatedWeight,
                "calculatedSize": self.state.calculatedSize,
                "commentFleet": self.state.commentFleet,
                "commentExpert": self.state.commentExpert,
                "paymentType": self.state.paymentType ? self.state.paymentType.value : null,
                "warehouse": {
                    "uuid": self.state.warehouse
                        && !self.state.commonWarehouses.find(itm => itm.value === self.state.warehouse.value)
                        ? self.state.warehouse.value
                        : null
                },
                "warehouseType": self.state.warehouseType
            },
            "address": {
                "name": self.state.name,
                "streetAddress": self.state.streetAddress,
                "streetNumber": self.state.streetNumber,
                "cityName": self.state.cityName,
                "postalCode": self.state.postalCode,
                "apartmentNumber": self.state.apartmentNumber,
                "apartmentFloor": self.state.apartmentFloor,
                "warehouse": self.state.warehousePlainText,
                "elevator": self.state.elevator,
                "contactPerson": self.state.contactPerson,
                "emailAddress": self.state.emailAddress,
                "mobilePhone": self.state.mobilePhone,
                "geoLat": self.state.geoLat,
                "geoLng": self.state.geoLng
            },
            "service": self.state.orderService,
            "element": self.state.orderElement,
            "slot": {
                "uuid": self.state.slot?.value || null
            },
            "schedule": {
                "uuid": (self.state.schedule) ? self.state.schedule.value : null
            },
            "zone": {
                "uuid": (self.state.calculatedZoneData) ? self.state.calculatedZoneData.uuid : null
            }
        };
        if (Array.isArray(ikeaServicesPayload) && ikeaServicesPayload.length) {
            requestPayload["services"] = ikeaServicesPayload;
        }

        _api.request(endpoint,
            requestPayload,
            (data) => {
                self.setState({
                    uuid: data.uuid,
                    ident: data.ident
                }, () => {
                    self.loadOrder(data.uuid);
                });
                self.popupSaved();
                self.props.setNavTitle(`Nowe zlecenie - ${data.ident}`);
                self.props.showNoty('tr', 'success', 'Zlecenie zostało zapisane');
                window.dispatchEvent(new CustomEvent('ORDER_SAVED', { 'detail': { 'status': true } }), true);
            },
            (error) => {
                self.setState({ isLoading: false });
                switch (error) {
                    case 'E_SLOT_EXHAUSTED':
                        self.props.showNoty('tr', 'error', 'Ten slot jest wypełniony, wybierz inny przedział czasowy');
                        break;

                    case 'E_POSTAL_CODE_CITY_NAME_MISMATCH':
                        self.props.showNoty('tr', 'error', 'Nazwa miejscowości nie jest zgodna z podanym kodem pocztowym');
                        break;

                    case 'E_ORDER_IS_LOCKED':
                        self.props.showNoty('tr', 'error', 'Zlecenie jest zablokowane, nie można edytować!');
                        break;

                    default:
                        self.popupError();
                        break;
                }
                window.dispatchEvent(new CustomEvent('ORDER_SAVED', { 'detail': { 'status': false, 'details': error } }), true);
            },
            (progress) => {
                self.props.setProgress(progress);
            }
        );
    }

    handleSubmit(event) {
        event.preventDefault();

        if (!this.state.isAdminView) {
            if (!this.state.slot) {
                if (this.state.userOwner.company.configuration.allowEmptyDate) {
                    //...
                } else if (this.state.userOwner.company.configuration.forceEmptyDate) {
                    // ...
                } else {
                    this.props.showNoty('tr', 'error', 'Musisz wybrać przedział czasowy');
                    return;
                }
            }
            if (this.state.slot && this.state.slot.value !== this.state.keepSlot) {
                if (this.state.slot.free - this.state.calculatedPoints < 0) {
                    this.props.showNoty('tr', 'error', 'To zamówienie przekracza pojemność slotu, wybierz inny przedział czasowy');
                    return;
                }
            }
        }
        let saveFn = () => { this.saveData() };
        let verifyFn = () => { this.popupDelayVerify(saveFn) }
        this.validateDelayRequest(saveFn, verifyFn);
    }

    onOrderSaved() {
        window.location.href = _api.config.app + `#/client/edit-order/${this.state.uuid}`;
    }

    popupSaved() {

        const onSavedAndHide = this.props.onSavedAndHide || this.showOrders.bind(this);
        const onSavedAndStay = this.props.onSavedAndStay || this.onOrderSaved.bind(this);

        this.setState({
            alert: (
                <SweetAlert
                    success
                    showCancel
                    style={{ display: "block", marginTop: "-196px" }}
                    title="Zlecenie zapisane"
                    cancelBtnText="Zamknij"
                    onCancel={() => { this.setState({ alert: null }); onSavedAndHide(); }}
                    confirmBtnText="Przejdź do edycji zlecenia"
                    onConfirm={() => { this.setState({ alert: null }); onSavedAndStay(); }}
                    confirmBtnBsStyle="info">
                </SweetAlert>
            )
        });

    }

    popupError() {
        this.setState({
            alert: (
                <SweetAlert
                    error
                    style={{ display: "block", marginTop: "-196px" }}
                    title="Wystąpił błąd podczas zapisu zlecenia"
                    confirmBtnText="Zamknij"
                    confirmBtnBsStyle="default"
                    onConfirm={() => this.setState({ alert: null })}>
                </SweetAlert>
            )
        });
    }

    popupDelayVerify(callback) {
        this.setState({
            alert: (
                <SweetAlert
                    info
                    showCancel
                    style={{ display: "block", marginTop: "-196px" }}
                    title="Czy jest to termin na życzenie klienta?"
                    confirmBtnText="Tak"
                    cancelBtnText="Nie"
                    onConfirm={() => { this.setState({ alert: null, delayRequest: true }, callback); }}
                    onCancel={() => { this.setState({ alert: null, delayRequest: false }, callback); }}
                    confirmBtnBsStyle="info">
                </SweetAlert>
            )
        });
    }

    showOrders() {
        this.setState({ alert: null });
        this.props.history.push('/client/orders');
    }

    onElementsChange = (elements) => {
        let calculatedWeight = 0;
        let calculatedSize = 0;
        let includeServiceUuid = null
        if (elements.length) {
            let weights = elements.map(item => item.trash ? 0 : parseFloat(item.weight) || 0);
            calculatedWeight = weights.reduce((prev, next) => prev + next) || 0;
            let sizes = elements.map(item => item.trash ? 0 : parseFloat(item.size) || 0);
            calculatedSize = sizes.reduce((prev, next) => prev + next) || 0;
        }
        if (this.state.availableServices && this.state.availableServices.length > 0) {
            for (let i = 0; i < this.state.availableServices.length; i++) {
                let service = this.state.availableServices[i];
                if (!service.autoRequired) {
                    continue;
                }
                if (this.parseFloatFixed(service.weight) < calculatedWeight) {
                    continue;
                }
                if (this.parseFloatFixed(service.size) < calculatedSize) {
                    continue;
                }
                includeServiceUuid = service.uuid;
                break;
            }
        }
        const stateUpdate = {
            orderElement: elements,
            calculatedWeight: calculatedWeight,
            calculatedSize: calculatedSize
        };
        this.setState(stateUpdate, () => {
            if (includeServiceUuid) {
                this.setState({
                    orderService: this.state.orderService.filter(item => { return !item.autoRequired })
                }, () => {
                    this.manageService(includeServiceUuid, true, true)
                });
            } else {
                this.calculateAll()
            }
        });
    }

    renameField = (ident, defaultValue) => {
        let fieldTranslation = this.state.userOwner.company.configuration.order.renameFields[ident];
        return fieldTranslation ? fieldTranslation.label : defaultValue;
    }

    hideField = (ident) => {
        return this.state.userOwner.company.configuration.order.hideFields.includes(ident)
    }

    shouldDisplayCalculatedPriceField = () => {
        if (this.state.isIkeaOrder) {
            return true;
        }
        const renameFields = this.state.userOwner.company.configuration.order.renameFields || {};
        return !!renameFields.calculatedPriceClient;
    }

    useIkeaValuePricing = () => {
        return this.state.isIkeaOrder;
    }

    getConfigPart = (ident) => {
        return this.state.userOwner.company.configuration[ident];
    }

    getAdditionalFieldConfiguration = (fieldName) => {
        const configuration = this.getCompanyConfiguration();
        if (!configuration || !configuration.order || !configuration.order.additionalFields) {
            return null;
        }
        return configuration.order.additionalFields[fieldName] || null;
    }

    canUseAdditionalField = (fieldConfiguration) => {
        if (!fieldConfiguration || !fieldConfiguration.for) {
            return true;
        }
        if (!this.props.userHasRole) {
            return true;
        }
        return this.props.userHasRole(fieldConfiguration.for);
    }

    getOrderTypeValue = () => {
        if (this.state.type && this.state.type.value) {
            return this.state.type.value;
        }
        if (Array.isArray(this.state.availableTypes) && this.state.availableTypes.length) {
            return this.state.availableTypes[0].value;
        }
        return null;
    }

    useAdditionalField = (useFields) => {

        let addonsFields = this.state.userOwner.company.configuration.order.additionalFields;
        return useFields.map(fld => {
            if (fld in addonsFields) {
                if (addonsFields[fld].for) {
                    if (!this.props.userHasRole(addonsFields[fld].for)) {
                        return null;
                    }
                }

                switch (addonsFields[fld].type) {
                    case "select":
                        return (
                            <fieldset key={"additional-" + fld}>
                                <FormGroup>
                                    <ControlLabel>{addonsFields[fld].label}:</ControlLabel>
                                    <Col>
                                        <Select
                                            className="react-select primary"
                                            classNamePrefix="react-select"
                                            value={addonsFields[fld].options.filter(itm => itm.value === this.state[fld])[0]}
                                            isDisabled={this.state.isPreviewOnly}
                                            placeholder="Wybierz.."
                                            onChange={event =>
                                                this.setState({ [fld]: event.value })
                                            }
                                            options={addonsFields[fld].options}
                                        />
                                    </Col>
                                </FormGroup>
                            </fieldset>
                        );

                    case "number":
                        return (
                            <fieldset key={"additional-" + fld}>
                                <FormGroup>
                                    <ControlLabel>{addonsFields[fld].label}:</ControlLabel>
                                    <FormControl
                                        type="number"
                                        placeholder={addonsFields[fld].placeholder || "(opcjonalnie)"}
                                        value={this.state[fld] || ""}
                                        min={addonsFields[fld].min}
                                        max={addonsFields[fld].max}
                                        step={addonsFields[fld].step || "1"}
                                        disabled={this.state.isPreviewOnly}
                                        onChange={event =>
                                            this.setState({ [fld]: event.target.value })
                                        }
                                    />
                                </FormGroup>
                            </fieldset>
                        );

                    case "express":
                        return (
                            <fieldset key={"additional-express"}>
                                <FormGroup>
                                    <Checkbox
                                        number="express"
                                        label="Express"
                                        checked={this.state.express}
                                        onChange={event =>
                                            this.setState({ express: event.target.checked })
                                        }
                                    />
                                </FormGroup>
                            </fieldset>
                        );

                    case "releaseElements":
                        return (
                            <fieldset key={"additional-releaseElements"}>
                                <FormGroup>
                                    <Checkbox
                                        number="releaseElements"
                                        label={addonsFields[fld].label}
                                        checked={this.state.releaseElements}
                                        onChange={event =>
                                            this.setState({ releaseElements: event.target.checked })
                                        }
                                    />
                                </FormGroup>
                            </fieldset>
                        );

                    default:
                        return (
                            <fieldset key={"additional-" + fld}>
                                <FormGroup>
                                    <ControlLabel>{addonsFields[fld].label}:</ControlLabel>
                                    <FormControl
                                        type="text"
                                        placeholder="(opcjonalnie)"
                                        value={this.state[fld]}
                                        disabled={this.state.isPreviewOnly}
                                        onChange={event =>
                                            this.setState({ [fld]: event.target.value })
                                        }
                                    />
                                </FormGroup>
                            </fieldset>
                        );
                }
            }
            return null;
        });
    }

    doesStatusRequireDeviationCode(statusValue, configuration) {
        if (!statusValue) {
            return false;
        }
        const configToUse = configuration || this.getCompanyConfiguration();
        const deviationField = this.getDeviationFieldConfiguration(configToUse);
        if (!deviationField || !this.canUseAdditionalField(deviationField)) {
            return false;
        }
        if (this.hasDeviationCodeRules(configToUse)) {
            return this.getDeviationCodeOptionsForStatusValue(statusValue, configToUse).length > 0;
        }
        return STATUSES_REQUIRING_DEVIATION_CODE.includes(statusValue);
    }

    requiresDeviationCode() {
        const statusValue = this.state.status ? this.state.status.value : null;
        return this.doesStatusRequireDeviationCode(statusValue);
    }

    validateDeviationCodesBeforeSave = () => {
        if (this.shouldUseServiceStatusManagement()) {
            const services = this.getIkeaServicesForCurrentOrder();
            if (!services.length) {
                return true;
            }
            const configuration = this.getCompanyConfiguration();
            for (let i = 0; i < services.length; i++) {
                const service = services[i];
                if (!service || !service.status) {
                    continue;
                }
                if (this.doesStatusRequireDeviationCode(service.status, configuration) && !service.deviationCode) {
                    const serviceLabel = service.name || service.sgr || `Usługa ${i + 1}`;
                    this.props.showNoty('tr', 'error', `Wybierz kod odchylenia dla pozycji: ${serviceLabel}`);
                    return false;
                }
            }
            return true;
        }
        return true;
    }

    getFilesList = () => {
        let filesList = [];
        let additionalFiles = [];
        let allFiles = [];
        for (let i = 0; i < this.state.additionalFiles.length; i++) {
            additionalFiles.push({ name: this.state.additionalFiles[i].name });
        }
        allFiles = this.state.currentFiles.concat(additionalFiles);
        for (let i = 0; i < allFiles.length; i++) {
            let elem = (<><i className="fa fa-file" /> {allFiles[i].name}</>);
            if (allFiles[i].url) {
                elem = (<a href={allFiles[i].url} target="_blank" rel="noopener noreferrer">{elem}</a>);
            }
            filesList.push(<p key={"file" + i}>{elem}</p>);
        }
        if (allFiles.filter(itm => itm.url !== '').length) {
            filesList.push(<p key={"file-all"}><a href={`${_api.config.url}link/zip/${this.state.uuid}?token=${_api.session.access_token}`} target="_blank" rel="noopener noreferrer"><i className="fa fa-file-archive-o" /> Pobierz wszystkie</a></p>);
        }
        return filesList;
    }

    generatePrinterLink() {
        let self = this;

        self.props.showNoty('tr', 'info', 'Generowanie dokumentów..');
        self.setState({ pdfIsGenerating: true });
        _api.request(`/admin/order/pdf`,
            {
                mode: "ordersList",
                orders: [{ "uuid": self.state.uuid }]
            },
            (data) => {
                self.setState({ pdfIsGenerating: false });
                if (data.url) {
                    window.open(data.url);
                }
            },
            (error) => {
                self.setState({ pdfIsGenerating: false });
                self.props.showNoty('tr', 'error', 'Wystąpił błąd podczas pobierania danych');
            },
            (progress) => {
                self.props.setProgress(progress);
            }
        );
    }

    generateAssemblyCopyPopup() {
        this.setState({
            alert: (
                <SweetAlert
                    info
                    showCancel
                    style={{ display: "block", marginTop: "-300px" }}
                    title="Czy chcesz utworzyć zlecenie montażu?"
                    confirmBtnText="Utwórz zlecenie montażu"
                    cancelBtnText="Anuluj"
                    onConfirm={() => { this.setState({ alert: null }); this.generateAssemblyCopy(); }}
                    onCancel={() => { this.setState({ alert: null }); }}
                    confirmBtnBsStyle="info">
                    Zostanie wykonany duplikat zlecenia, bez przypisanego slotu czasowego. Przed wykonaniem operacji, zapisz aktualne zlecenie.
                </SweetAlert>
            )
        });
    }

    generateAssemblyCopy() {
        let self = this;
        self.props.showNoty('tr', 'info', `Kopiowanie zlecenia ${self.state.ident}`);
        _api.request(`/order/duplicate/${self.state.uuid}`,
            {
                "order": {
                    "type": "assembly"
                }
            },
            (data) => {
                self.props.showNoty('tr', 'success', `Numer nowego zlecenia: ${data.ident}`);
                self.openAssemblyCopy(data.uuid);
            },
            (error) => {
                self.props.showNoty('tr', 'error', 'Wystąpił błąd podczas pobierania danych');
            },
            (progress) => {
                self.props.setProgress(progress);
            }
        );
    }

    openAssemblyCopy(uuid) {
        setTimeout(() => {
            window.location.href = _api.config.app + `#/client/edit-order/${uuid}`;
        }, 600);
    }

    handleLockToggle() {
        const currentState = this.state.lockState;
        let newState = "open";

        if (currentState === "open") {
            newState = "locked";
        } else if (currentState === "locked") {
            newState = "adminOnly";
        } else if (currentState === "adminOnly") {
            newState = "locked";
        }

        _api.request(`/order/lock/${this.state.uuid}`,
            {
                "lockState": newState
            },
            (data) => {
                const isPreviewNow = (newState === "locked");

                this.setState({ lockState: newState, isPreviewOnly: isPreviewNow });
                let msg = "";
                if (newState === "locked") msg = "Zlecenie zablokowane";
                if (newState === "adminOnly") msg = "Tryb edycji administratora";
                if (newState === "open") msg = "Zlecenie otwarte dla wszystkich";

                this.props.showNoty('tr', 'success', msg);
            },
            (error) => {
                switch (error) {
                    case 'E_ORDER_NOT_FOUND':
                        this.props.showNoty('tr', 'error', 'Zlecenie o podanym numerze nie zostało znalezione');
                        break;

                    case 'E_INVALID_IS_LOCKED_VALUE':
                        this.props.showNoty('tr', 'error', 'Błąd ustawianej wartości blokady zlecenia');
                        break;

                    case 'E_LOGGED_USER_NOT_FOUND':
                        this.props.showNoty('tr', 'error', 'Błąd podcczas pobierania informacji o zalogowanym użytkowniku');
                        break;

                    case 'E_CANT_EDIT_LOCKED_ORDERS':
                        this.props.showNoty('tr', 'error', 'Nie możesz edytować zablokowanych zleceń');
                        break;

                    default:
                        this.props.showNoty('tr', 'error', 'Wystąpił błąd podczas pobierania danych');
                        break;
                }
                this.props.showNoty('tr', 'error', 'Błąd: ' + error); }
        );
    }

    render() {

        const filesList = this.getFilesList();

        let directionsFrom = this.state.userOwner.company.address.streetAddress;
        let directionsCenter = { lat: parseFloat(this.state.userOwner.company.address.geoLat) || 52.237049, lng: parseFloat(this.state.userOwner.company.address.geoLng) || 21.017532 };

        if (
            this.state.realUserCompanyName === 'MediaMarkt [NET]' ||
            (this.state.calculateDeliveryFromWarehouse &&
            this.state.lastMileWarehouseStreetAddress &&
            this.state.lastMileWarehouseStreetNumber &&
            this.state.lastMileWarehousePostalCode &&
            this.state.lastMileWarehouseCityName &&
            this.state.lastMileWarehouseGeoLat &&
            this.state.lastMileWarehouseGeoLng)
        ) {
            const streetAddress = this.state.lastMileWarehouseStreetAddress;
            const streetNumber = this.state.lastMileWarehouseStreetNumber;
            const postalCode = this.state.lastMileWarehousePostalCode;
            const cityName = this.state.lastMileWarehouseCityName;
            directionsFrom = `${streetAddress} ${streetNumber}, ${postalCode} ${cityName}`;
            directionsCenter = { lat: parseFloat(this.state.lastMileWarehouseGeoLat) || 52.237049, lng: parseFloat(this.state.lastMileWarehouseGeoLng) || 21.017532 };
        }

        const orderLoading = (
            <div className="main-content">
                <div style={{ "paddingBottom": "26px" }}>
                    <PropagateLoader
                        sizeUnit={"px"}
                        size={15}
                        margin={2}
                        css={{
                            "display": "block",
                            "margin": "10px auto",
                            "width": "1px"
                        }}
                        color={'#777'}
                        loading={true}
                    />
                </div>
            </div>
        );

        const elementsList = (
            <ExpertElementsListComponent
                elements={this.state.orderElement ? this.state.orderElement : []}
                listType={this.state.userOwner.company.configuration.order.element.type}
                companyIndustry={this.state.userOwner.company.industry}
                assemblyMode={this.state.type && this.state.type.value === "assembly"}
                showNoty={this.props.showNoty}
                setProgress={this.props.setProgress}
                onElementsChange={this.onElementsChange}
                isPreviewOnly={this.state.isPreviewOnly}
                eInvoice={this.state.eInvoice}
                useValueColumn={this.state.isIkeaOrder}
                valueColumnLabel={this.renameField('elementValue', 'Cena')}
                showQuantityColumn={this.state.isIkeaOrder}
                showAssemblyTimeColumn={this.state.isIkeaOrder}
                assemblyTimeColumnLabel={this.renameField('assemblyTimeMinutes', this.renameField('elementAssemblyTimeMinutes', 'Czas montażu (min)'))}
            />
        );

        const printerButton = this.state.uuid && (
            <Button
                onClick={() => { this.generatePrinterLink() }}
                bsStyle="primary"
                fill wd
                icon>
                <i className="fa fa-print" /> Wydrukuj
            </Button>
        )

        const assemblyItems = this.state.children.filter((subOrder) => { return subOrder.type === 'assembly' });

        const assemblyButton =
            (
                this.state.uuid
                && (!this.state.type || this.state.type?.value !== 'assembly')
                && this.state.userOwner.company.configuration.order.buttons.includes("assembly")
            )
                ?
                assemblyItems.length === 0
                    ?
                    (
                        <Button
                            onClick={() => { this.generateAssemblyCopyPopup() }}
                            bsStyle="default"
                            fill wd
                            icon>
                            <i className="fa fa-wrench" /> <>Nowe zlecenie montażu</>
                        </Button>
                    )
                    :
                    (
                        <Button
                            onClick={() => { this.openAssemblyCopy(assemblyItems[0].uuid) }}
                            bsStyle="default"
                            fill wd
                            icon>
                            <i className="fa fa-wrench" /> <>Zobacz zlecenie montażu</>
                        </Button>
                    )
                :
                null;

        const typeSwitch = this.state.userOwner.company.configuration.order.buttons.includes("assembly") && (
            <FormGroup>
                <ControlLabel>Rodzaj usługi:</ControlLabel>
                <Col>
                    <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        value={this.state.type || this.state.availableTypes[0]}
                        isDisabled={this.state.isPreviewOnly}
                        placeholder="Wybierz.."
                        onChange={value =>
                            this.setState({ type: value, withoutDelivery: value.value === "assembly" }, () => { this.calculateAll(); })
                        }
                        options={this.state.availableTypes}
                    />
                </Col>
            </FormGroup>
        )

        const isVisuallyLocked = (this.state.lockState === 'locked');

        const canEditLockedOrders = this.state.canEditLockedOrders;

        const showLockButton = canEditLockedOrders && (this.state.lockState === 'locked' || this.state.lockState === 'adminOnly');

        const lockButton = showLockButton && (
            <Button
                bsStyle={isVisuallyLocked ? "info" : "warning"}
                fill wd icon
                onClick={() => { this.handleLockToggle(); }}
            >
                <i className={isVisuallyLocked ? "fa fa-lock" : "fa fa-unlock"} />
                {isVisuallyLocked ? " Odblokuj zlecenie" : " Zablokuj zlecenie"}
            </Button>
        )

        const serviceType = this.state.userOwner.company.configuration.order.additionalFields.hasOwnProperty('serviceType') && (
          <FormGroup>
            <ControlLabel>Pakiet usług:</ControlLabel>
            <FormControl
              type="text"
              name="serviceType"
              disabled={true}
              value={this.state.serviceType || ""}
            />
          </FormGroup>
        )

        const adminToolkitPrice = this.state.isAdminView && !this.useIkeaValuePricing() && (
            <div>
                <FormGroup>
                    <Checkbox
                        number="manualPriceClient"
                        label="Zatrzymaj automatyczną kalkulację"
                        checked={this.state.manualPriceClient}
                        onChange={event =>
                            this.setState({ manualPriceClient: event.target.checked }, () => { if (!this.state.manualPriceClient) { this.calculateAll() } })
                        }
                    />
                </FormGroup>
            </div>
        );

        const internalOrderStatusOptions = this.getStatusOptions(false, this.getCompanyConfiguration());

        const adminToolkit = this.state.isAdminView && (
            <div>
                {this.state.isIkeaOrder && (
                    <FormGroup>
                        <ControlLabel>Status zlecenia (wewnętrzny):</ControlLabel>
                        <Col>
                            <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                value={this.state.orderStatus}
                                placeholder="Wybierz.."
                                onChange={value =>
                                    this.handleOrderStatusChange(value)
                                }
                                options={internalOrderStatusOptions}
                                isDisabled={this.state.isPreviewOnly}
                            />
                        </Col>
                    </FormGroup>
                )}
                <FormGroup>
                    <ControlLabel>Obliczone punkty:</ControlLabel>
                    <FormControl
                        type="text"
                        name="calculatedPoints"
                        value={this.state.calculatedPoints || "0"}
                        onChange={
                            event => {
                                let value = event.target.value.replace(",", ".");
                                this.setState({ calculatedPoints: value })
                            }
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Przypisany harmonogram:</ControlLabel>
                    <Col>
                        <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="schedule"
                            value={this.state.schedule}
                            placeholder="Wybierz.."
                            onChange={value =>
                                this.setState({ schedule: value })
                            }
                            options={this.state.availableSchedule}
                            isClearable={true}
                            isDisabled={this.state.isPreviewOnly}
                        />
                    </Col>
                </FormGroup>
                {this.renderIkeaServiceSelector()}
                <FormGroup>
                    <ControlLabel>Ustaw nowy status:</ControlLabel>
                    <Col>
                        <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            value={this.state.status}
                            placeholder="Wybierz.."
                            onChange={value =>
                                this.handleStatusChange(value)
                            }
                            options={this.state.statusOptions}
                            isDisabled={this.state.isPreviewOnly}
                        />
                    </Col>
                </FormGroup>
                {this.renderDeviationCodeField()}
                <FormGroup>
                    <ControlLabel>Notatka EXPERT:</ControlLabel>
                    <textarea
                        className="form-control"
                        value={this.state.commentExpert}
                        rows={3}
                        onChange={event =>
                            this.setState({ commentExpert: event.target.value })
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Notatka Floty:</ControlLabel>
                    <textarea
                        className="form-control"
                        value={this.state.commentFleet}
                        rows={3}
                        onChange={event =>
                            this.setState({ commentFleet: event.target.value })
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <Checkbox
                        number="settled"
                        label="Zlecenie zostało rozliczone"
                        checked={this.state.settled}
                        disabled={this.state.wasSettled}
                        onChange={event =>
                            this.setState({ settled: event.target.checked })
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Załączone pliki:</ControlLabel>
                    <ExpertUploadComponent
                        onSelectedFiles={this.handleAdditionalFilesSelected}
                        onValidationError={this.handleAdditionalFilesValidationError}
                        acceptedExtensions={this.state.isIkeaOrder ? IKEA_ALLOWED_FILE_EXTENSIONS : null}
                        isDisabled={this.state.isPreviewOnly}
                    />
                </FormGroup>
                {filesList}
                <fieldset className="pull-right text-danger">
                    <FormGroup>
                        <Checkbox
                            number="trash"
                            label="Anuluj zlecenie"
                            checked={this.state.trash}
                            onChange={event =>
                                this.setState({ trash: event.target.checked })
                            }
                        />
                    </FormGroup>
                </fieldset>
            </div>
        );

        const paymentTypeOptions = this.state.payer && this.state.payer.paymentType && (
            <FormGroup>
                <ControlLabel>Opcje płatności:</ControlLabel>
                <Col>
                    <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        placeholder="Wybierz.."
                        value={this.state.paymentType}
                        onChange={object =>
                            this.setState({ paymentType: object })
                        }
                        options={this.state.payer.paymentType}
                        isDisabled={this.state.isPreviewOnly}
                    />
                </Col>
            </FormGroup>
        );

        const paymentTypeVoucher = this.state.payer && this.state.paymentType && this.state.paymentType.useVouchers && (
            <div>
                <FormGroup>
                    <ControlLabel>Numer bonu:</ControlLabel>
                    <FormControl
                        type="text"
                        name="identExternalVoucher"
                        value={this.state.identExternalVoucher}
                        disabled={this.state.isPreviewOnly}
                        placeholder="..."
                        onChange={
                            event => {
                                let value = event.target.value.replace(",", ".");
                                this.setState({ identExternalVoucher: value })
                            }
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Wartość bonu:</ControlLabel>
                    <FormControl
                        type="text"
                        name="discountValue"
                        value={this.state.discountValue}
                        disabled={this.state.isPreviewOnly}
                        placeholder="..."
                        onChange={
                            event => {
                                let value = event.target.value.replace(",", ".");
                                this.setState({ discountValue: value }, () => { this.calculateAll() })
                            }
                        }
                    />
                </FormGroup>
            </div>
        );

        const showCalculatedPriceField = this.shouldDisplayCalculatedPriceField();
        const hideCalculatedSizeField = this.hideField("calculatedSize");
        const canShowPriceField = showCalculatedPriceField && !this.hideField("calculatedPriceClient");
        const calculatedPriceLabel = this.state.isIkeaOrder ? this.renameField('ikeaSumNetValue', this.renameField('calculatedPriceClient', 'Cena')) : this.renameField('calculatedPriceClient', 'Cena');
        const calculatedPriceSummaryValue = this.state.isIkeaOrder
            ? (this.state.ikeaSumNetValue !== null && this.state.ikeaSumNetValue !== undefined && this.state.ikeaSumNetValue !== ""
                ? this.state.ikeaSumNetValue
                : this.getElementsValueTotal(this.state.orderElement))
            : this.state.calculatedPriceClient;
        const ikeaAssemblyTimeField = this.state.isIkeaOrder && (
            <FormGroup>
                <ControlLabel>{this.renameField('ikeaAssemblyTimeTotalMinutes', 'Łączny czas montażu (min)')}:</ControlLabel>
                <FormControl
                    type="text"
                    disabled={true}
                    value={this.formatMinutesValue(this.state.ikeaAssemblyTimeTotalMinutes)}
                    onChange={e => { e.preventDefault() }}
                />
            </FormGroup>
        );
        const serviceCostField = (
            <FormGroup>
                <ControlLabel>Koszt usługi (PLN):</ControlLabel>
                <FormControl
                    type="text"
                    disabled={!this.state.isAdminView || this.useIkeaValuePricing()}
                    value={this.state.calculatedPriceClient}
                    onChange={
                        event => {
                            let value = event.target.value.replace(",", ".");
                            this.setState({ calculatedPriceClient: value })
                        }
                    }
                />
            </FormGroup>
        );
        const serviceCostSummary = this.state.isIkeaOrder ? (
            <Row>
                <Col sm={6}>
                    {ikeaAssemblyTimeField}
                </Col>
                <Col sm={6}>
                    {serviceCostField}
                </Col>
            </Row>
        ) : serviceCostField;
        const calculatedZoneUnit = this.state.userOwner.company.configuration.zones.mode === "perimeter" ?
            (
                <FormGroup>
                    <ControlLabel>Liczba kilometrów:</ControlLabel>
                    <FormControl
                        type="text"
                        disabled={true}
                        value={this.state.calculatedDistance}
                        onChange={
                            event => {
                                let value = event.target.value.replace(",", ".");
                                this.setDistance(value);
                            }
                        }
                    />
                </FormGroup>
            ) : (
                <Row>
                    <Col sm={6}>
                        <FormGroup>
                            <ControlLabel>Łączna&nbsp;waga:</ControlLabel>
                            <FormControl
                                type="text"
                                disabled={true}
                                value={this.parseFloatFixed(this.state.calculatedWeight).toFixed(2)}
                                onChange={e => { e.preventDefault() }}
                            />
                        </FormGroup>
                    </Col>
                    {canShowPriceField ? (
                        <Col sm={6}>
                            <FormGroup>
                                <ControlLabel>{calculatedPriceLabel}:</ControlLabel>
                                <FormControl
                                    type="text"
                                    disabled={true}
                                    value={this.formatPriceValue(calculatedPriceSummaryValue)}
                                    onChange={e => { e.preventDefault() }}
                                />
                            </FormGroup>
                        </Col>
                    ) : (!hideCalculatedSizeField && (
                        <Col sm={6}>
                            <FormGroup>
                                <ControlLabel>Łączna&nbsp;obj.:</ControlLabel>
                                <FormControl
                                    type="text"
                                    disabled={true}
                                    value={this.parseFloatFixed(this.state.calculatedSize).toFixed(2)}
                                    onChange={e => { e.preventDefault() }}
                                />
                            </FormGroup>
                        </Col>
                    ))}
                </Row>
            );

        const orderLoaded = (
            <div className="main-content">
                {this.state.alert}
                <Grid fluid>
                    <Row>
                        <form onSubmit={this.handleSubmit.bind(this)}>
                            <Col md={6}>
                                <fieldset disabled={this.state.isPreviewOnly} style={{ border: 'none', padding: 0, width: '100%' }}>
                                    <Card
                                        title="Dane odbiorcy"
                                        content={
                                            <div>
                                                <FormGroup>
                                                    <ControlLabel>Imię i nazwisko lub nazwa firmy:</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        value={this.state.name}
                                                        disabled={this.state.isPreviewOnly}
                                                        onChange={event =>
                                                            this.setState({ name: event.target.value })
                                                        }
                                                    />
                                                </FormGroup>
                                                <Row>
                                                    <Col md={4}>
                                                        <FormGroup>
                                                            <ControlLabel>Kod pocztowy:</ControlLabel>
                                                            <DebounceInput
                                                                className="form-control"
                                                                minLength={2}
                                                                debounceTimeout={10000}
                                                                type="text"
                                                                value={this.state.postalCode}
                                                                disabled={this.state.isPreviewOnly}
                                                                onChange={event =>
                                                                    this.setAddress({ postalCode: event.target.value })
                                                                }
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={8}>
                                                        <FormGroup>
                                                            <ControlLabel>Miasto:</ControlLabel>
                                                            <DebounceInput
                                                                className="form-control"
                                                                minLength={2}
                                                                debounceTimeout={10000}
                                                                type="text"
                                                                value={this.state.cityName}
                                                                disabled={this.state.isPreviewOnly}
                                                                onChange={event =>
                                                                    this.setAddress({ cityName: event.target.value })
                                                                }
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md={6}>
                                                        <FormGroup>
                                                            <ControlLabel>Ulica:</ControlLabel>
                                                            <DebounceInput
                                                                className="form-control"
                                                                minLength={2}
                                                                debounceTimeout={10000}
                                                                type="text"
                                                                value={this.state.streetAddress}
                                                                disabled={this.state.isPreviewOnly}
                                                                onChange={event =>
                                                                    this.setAddress({ streetAddress: event.target.value })
                                                                }
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <ControlLabel>Nr domu:</ControlLabel>
                                                            <DebounceInput
                                                                className="form-control"
                                                                minLength={1}
                                                                debounceTimeout={10000}
                                                                type="text"
                                                                value={this.state.streetNumber}
                                                                disabled={this.state.isPreviewOnly}
                                                                onChange={event =>
                                                                    this.setAddress({ streetNumber: event.target.value })
                                                                }
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <ControlLabel>Nr lokalu:</ControlLabel>
                                                            <FormControl
                                                                type="text"
                                                                placeholder="(opcjonalnie)"
                                                                value={this.state.apartmentNumber}
                                                                disabled={this.state.isPreviewOnly}
                                                                onChange={event =>
                                                                    this.setState({ apartmentNumber: event.target.value })
                                                                }
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                <FormGroup>
                                                    <ControlLabel>Osoba kontaktowa:</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        placeholder="(opcjonalnie)"
                                                        value={this.state.contactPerson}
                                                        onChange={event =>
                                                            this.setState({ contactPerson: event.target.value })
                                                        }
                                                    />
                                                </FormGroup>
                                                <FormGroup>
                                                    <ControlLabel>E-mail:</ControlLabel>
                                                    <FormControl
                                                        type="email"
                                                        placeholder="(opcjonalnie)"
                                                        value={this.state.emailAddress}
                                                        onChange={event =>
                                                            this.setState({ emailAddress: event.target.value })
                                                        }
                                                    />
                                                </FormGroup>
                                                <FormGroup>
                                                    <ControlLabel>Telefon:</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        value={this.state.mobilePhone}
                                                        onChange={event =>
                                                            this.setState({ mobilePhone: event.target.value })
                                                        }
                                                    />
                                                </FormGroup>
                                            </div>
                                        }
                                    />

                                    {elementsList}

                                    <Card
                                        title="Szczegóły"
                                        content={
                                            <div>
                                                {
                                                    this.state.availableServices && this.state.availableServices.length > 0 && (
                                                        <FormGroup>
                                                            <ControlLabel>Usługi dodatkowe:</ControlLabel>
                                                            <Col>
                                                                {
                                                                    this.state.availableServices.map((prop, key) => {
                                                                        let serviceQuantity = this.state.orderService.find(e => e.uuid === prop.uuid) ? this.state.orderService.find(e => e.uuid === prop.uuid).quantity : 0;
                                                                        if (prop.autoRequired) {
                                                                            return null;
                                                                        }
                                                                        return (
                                                                            <Checkbox
                                                                                key={prop.uuid}
                                                                                number={"service-" + key}
                                                                                label={
                                                                                    <FormGroup>
                                                                                        <FormControl
                                                                                            type="text"
                                                                                            placeholder="ilość"
                                                                                            value={serviceQuantity}
                                                                                            disabled={this.state.isPreviewOnly || prop.autoRequired}
                                                                                            style={{ "borderRadius": "2px", "height": "24px", "width": "48px", "padding": "0", "display": "inline", "marginTop": "-2px", "marginRight": "5px", "textAlign": "center" }}
                                                                                            onChange={event =>
                                                                                                this.manageServiceQuantity(prop.uuid, event.target.value)
                                                                                            }
                                                                                        />
                                                                                        {prop.name}
                                                                                    </FormGroup>
                                                                                }
                                                                                checked={this.state.orderService.some(e => e.uuid === prop.uuid)}
                                                                                disabled={this.state.isPreviewOnly || prop.autoRequired}
                                                                                onChange={event => {
                                                                                    this.manageService(prop.uuid, event.target.checked);
                                                                                }}
                                                                            />
                                                                        );
                                                                    })
                                                                }
                                                                {!this.hideField("withoutDelivery") && (
                                                                    <Checkbox
                                                                        className="text-warning"
                                                                        number="withoutDelivery"
                                                                        label="Zlecenie bez usługi dostawy"
                                                                        checked={this.state.withoutDelivery}
                                                                        disabled={this.state.isPreviewOnly}
                                                                        onChange={(event) =>
                                                                            this.setState({ withoutDelivery: event.target.checked },
                                                                                () => {
                                                                                    this.calculateAll()
                                                                                }
                                                                            )
                                                                        }
                                                                    />
                                                                )}

                                                                {this.getConfigPart('allowNoBringing') && (
                                                                    <Checkbox
                                                                        number="allowNoBringing"
                                                                        label={"Zlecenie bez usługi wniesienia"}
                                                                        checked={this.state.allowNoBringing}
                                                                        onChange={event =>
                                                                            this.setState({ allowNoBringing: event.target.checked }, () => { this.calculateAll() })
                                                                        }
                                                                    />
                                                                )}
                                                            </Col>
                                                        </FormGroup>
                                                    )
                                                }
                                                {this.renderIkeaServicesPreview()}
                                                <FormGroup>
                                                    <ControlLabel>Piętro:</ControlLabel>
                                                    <FormControl
                                                        type="number"
                                                        placeholder="(opcjonalnie)"
                                                        value={this.state.apartmentFloor}
                                                        disabled={this.state.isPreviewOnly}
                                                        onChange={event =>
                                                            this.setState({ apartmentFloor: event.target.value })
                                                        }
                                                    />
                                                    <Checkbox
                                                        number="elevator"
                                                        label="Budynek posiada windę"
                                                        checked={this.state.elevator}
                                                        disabled={this.state.isPreviewOnly}
                                                        onChange={(event) =>
                                                            this.setState({ elevator: event.target.checked })
                                                        }
                                                    />
                                                </FormGroup>
                                                {!this.hideField("warehouse") && (
                                                    <FormGroup>
                                                        <ControlLabel>Magazyn:</ControlLabel>
                                                        <Col>
                                                            <Select
                                                                className="react-select primary"
                                                                classNamePrefix="react-select"
                                                                placeholder="Wybierz.."
                                                                options={this.state.warehouses}
                                                                value={this.state.warehouse}
                                                                isDisabled={this.state.isPreviewOnly}
                                                                isClearable={!this.hideField("emptyWarehouse")}
                                                                onChange={value => {
                                                                    let warehouseNewType = value ? "defined" : "other";
                                                                    let isInCommonSet = value ? this.state.commonWarehouses.find(itm => itm.value === value.value) : null;
                                                                    if (isInCommonSet) {
                                                                        warehouseNewType = isInCommonSet.value;
                                                                    }
                                                                    this.setState({
                                                                        warehouse: value,
                                                                        warehousePlainText: value && value.value !== "other" ? value.label : "",
                                                                        warehouseType: warehouseNewType
                                                                    });
                                                                }}
                                                            />
                                                        </Col>
                                                        {
                                                            this.state.warehouseType === "other" && (
                                                                <div style={{ marginTop: 10 }}>
                                                                    <FormControl
                                                                        type="text"
                                                                        placeholder={!this.hideField("warehouse") ? "podaj magazyn" : "(opcjonalnie)"}
                                                                        value={this.state.warehousePlainText}
                                                                        disabled={this.state.isPreviewOnly}
                                                                        onChange={event =>
                                                                            this.setState({ warehousePlainText: event.target.value })
                                                                        }
                                                                    />
                                                                </div>
                                                            )
                                                        }
                                                        {this.useAdditionalField(['releaseElements'])}
                                                    </FormGroup>
                                                )}
                                                <FormGroup>
                                                    <ControlLabel>Uwagi:</ControlLabel>
                                                    <textarea
                                                        className="form-control"
                                                        value={this.state.comment}
                                                        onChange={event =>
                                                            this.setState({ comment: event.target.value })
                                                        }
                                                    />
                                                </FormGroup>
                                            </div>
                                        }
                                    />
                                </fieldset>
                            </Col>
                            <Col md={6}>
                                <fieldset disabled={this.state.isPreviewOnly} style={{ border: 'none', padding: 0 }}>
                                    <MapCard
                                        title="Podgląd trasy"
                                        content={
                                            <DirectionsMap
                                                origin={directionsFrom}
                                                destination={this.state.fullAddress}
                                                onDirectionsChange={this.onDirectionsChange}
                                                onDirectionsNotFound={this.onDirectionsNotFound}
                                                defaultCenter={directionsCenter}
                                                loadingElement={<div style={{ height: `100%` }} />}
                                                containerElement={<div style={{ height: `280px` }} />}
                                                mapElement={<div style={{ height: `100%` }} />}
                                                placeholder="Ustaw adres docelowy"
                                            />
                                        }
                                    />

                                    <Card
                                        title="Podsumowanie"
                                        content={
                                            <div>
                                                {typeSwitch}
                                                <Row>
                                                    <Col xs={6}>
                                                        {calculatedZoneUnit}
                                                    </Col>
                                                    <Col xs={6}>
                                                        <FormGroup>
                                                            <ControlLabel>Obliczona strefa:</ControlLabel>
                                                            <FormControl
                                                                type="text"
                                                                placeholder="Strefa.."
                                                                disabled={true}
                                                                value={this.state.calculatedZone ? "Strefa: " + this.state.calculatedZone : ""}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                                {serviceCostSummary}
                                                {adminToolkitPrice}
                                                {serviceType}
                                                <FormGroup>
                                                    <ControlLabel>Płatność:</ControlLabel>
                                                    <Col>
                                                        <Select
                                                            className="react-select primary"
                                                            classNamePrefix="react-select"
                                                            value={this.state.payer}
                                                            placeholder="Wybierz.."
                                                            onChange={value =>
                                                                this.setState({ payer: value, paymentType: null })
                                                            }
                                                            options={this.state.payerOptions}
                                                            isDisabled={this.state.isPreviewOnly}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                                {paymentTypeOptions}
                                                {paymentTypeVoucher}
                                                <FormGroup>
                                                    <ControlLabel>{this.renameField('identExternal', 'Numer dokumentu')}:</ControlLabel>
                                                    <FormControl
                                                        type="text"
                                                        placeholder="(opcjonalnie)"
                                                        value={this.state.identExternal}
                                                        disabled={this.state.isPreviewOnly}
                                                        onChange={event =>
                                                            this.setState({ identExternal: event.target.value })
                                                        }
                                                    />
                                                </FormGroup>
                                                {this.useAdditionalField(['cod'])}
                                                {
                                                    (!this.state.isAdminView && this.state.userOwner.company.configuration.forceEmptyDate) ? (
                                                        <></>
                                                    ) : (
                                                        <FormGroup>
                                                            <ControlLabel>{this.renameField('slot', 'Termin dostawy')}:</ControlLabel>
                                                            <Col>
                                                                <Select
                                                                    className="react-select primary"
                                                                    classNamePrefix="react-select"
                                                                    value={this.state.slot}
                                                                    placeholder="Wybierz.."
                                                                    onChange={value =>
                                                                        this.setState({ slot: value })
                                                                    }
                                                                    options={this.state.availableSlots}
                                                                    isDisabled={this.state.isPreviewOnly}
                                                                />
                                                            </Col>
                                                        </FormGroup>
                                                    )
                                                }
                                                {this.useAdditionalField(['delayRequest'])}
                                                {this.useAdditionalField(['expressRequest'])}
                                                {this.useAdditionalField(['transferable'])}
                                            </div>
                                        }
                                    />
                                </fieldset>

                                <Card
                                    title="Opcje"
                                    content={
                                        <div>
                                            <fieldset disabled={this.state.isPreviewOnly} style={{ border: 'none', padding: 0 }}>
                                                {adminToolkit}
                                            </fieldset>
                                            <div className="buttons-with-margin">
                                                <fieldset disabled={this.state.isPreviewOnly} style={{ border: 'none', padding: 0, display: 'inline-block' }}>
                                                    <Button id="btn-save-order" type="submit" disabled={this.state.isLoading} bsStyle="success" fill wd icon onClick={!this.state.isLoading ? this.handleSubmit.bind(this) : null}>
                                                        <i className="fa fa-save" />  {this.state.isLoading ? 'Zapisywanie…' : this.state.isPreviewOnly ? 'Zapisz komentarz' : 'Zapisz zlecenie'}
                                                    </Button>
                                                </fieldset>
                                                {printerButton}
                                                {assemblyButton}
                                                {lockButton}
                                            </div>
                                        </div>
                                    }
                                />
                            </Col>
                        </form>
                    </Row>
                </Grid>
            </div>
        );

        return (
            <div>
                {this.state.orderLoading ? orderLoading : orderLoaded}
            </div>
        )

    }
}

export default ExpertClientOrder;
